
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("lF9wS", function(module, exports) {
/* date-picker.tsx generated by @compiled/babel-plugin v3.0.2 */ /// <reference types="node" />
// for typing `process`

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $esV19 = parcelRequire("esV19");

var $k5sGX = parcelRequire("k5sGX");


var $7r5Hr = parcelRequire("7r5Hr");


var $1sCHt = parcelRequire("1sCHt");


var $w6R6I = parcelRequire("w6R6I");


var $6JrSr = parcelRequire("6JrSr");


var $824lD = parcelRequire("824lD");


var $3vMGL = parcelRequire("3vMGL");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");


var $1TlML = parcelRequire("1TlML");


var $6wGOF = parcelRequire("6wGOF");


var $2DcxV = parcelRequire("2DcxV");


var $7P40I = parcelRequire("7P40I");


var $c1tjA = parcelRequire("c1tjA");


var $3YIJ0 = parcelRequire("3YIJ0");


var $jchtB = parcelRequire("jchtB");


var $6bH7j = parcelRequire("6bH7j");


var $dDPKN = parcelRequire("dDPKN");


var $goKry = parcelRequire("goKry");


var $dAzeP = parcelRequire("dAzeP");


var $cME0o = parcelRequire("cME0o");


var $lzTfS = parcelRequire("lzTfS");


var $ep7Ex = parcelRequire("ep7Ex");

const $c67bd6933458bbbd$var$packageName = "platform-pkg";
const $c67bd6933458bbbd$var$packageVersion = "0.0.0-use.local";
const $c67bd6933458bbbd$var$styles = {
    pickerContainerStyle: "_1mT5xdRAKS",
    dropdownIndicatorStyles: "_4ouGXI9DVM _4kiQYA9DVM _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT",
    iconContainerStyles: "_23rrnHYru2 _3iDTPbQ4SZ _0jFU0VN91d _1mT5xdWVPG _0hPCNLDIqT _1bHrqEOLYo _1UtDYzKGUX _2I62gzPgdg _1OKFqYPgdg _0clgaMZpcK",
    iconSpacingWithClearButtonStyles: "_2xTnZxVa5s",
    iconSpacingWithoutClearButtonStyles: "_2xTnZx1Y8M"
};
const $c67bd6933458bbbd$var$analyticsAttributes = {
    componentName: 'datePicker',
    packageName: $c67bd6933458bbbd$var$packageName,
    packageVersion: $c67bd6933458bbbd$var$packageVersion
}; /**
    * __Date picker__
    *
    * A date picker allows the user to select a particular date.
    *
    * - [Examples](https://atlassian.design/components/datetime-picker/date-picker/examples)
    * - [Code](https://atlassian.design/components/datetime-picker/date-picker/code)
    * - [Usage](https://atlassian.design/components/datetime-picker/date-picker/usage)
    */ 
const $c67bd6933458bbbd$var$DatePicker = /*#__PURE__*/ (0, $cozmU.forwardRef)((props, _forwardedRef)=>{
    const containerRef = (0, $cozmU.useRef)(null);
    const calendarRef = (0, $cozmU.useRef)(null);
    const calendarButtonRef = (0, $cozmU.useRef)(null); // Track whether focus was caused by an active pointer gesture. Pointer-driven focus must defer
    // opening a top-layer popover until click, while keyboard and programmatic focus can open it now.
    const isPointerInteractionRef = (0, $cozmU.useRef)(false);
    const focusRestorationTargetRef = (0, $cozmU.useRef)(null);
    const { appearance: appearance = 'default', autoFocus: autoFocus = false, clearControlLabel: clearControlLabel = 'Clear', hideIcon: hideIcon = false, openCalendarLabel: openCalendarLabel = 'Open calendar', defaultIsOpen: defaultIsOpen = false, defaultValue: defaultValue = '', disabled: disabled = [], disabledDateFilter: disabledDateFilter = (_)=>false, icon: Icon = (0, (/*@__PURE__*/$parcel$interopDefault($824lD))), id: id = '', innerProps: innerProps = {}, inputLabel: inputLabel = 'Date picker', inputLabelId: inputLabelId, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isRequired: isRequired = false, label: label = '', name: name = '', onBlur: /* eslint-disable @repo/internal/react/use-noop */ onBlur = (_event)=>{}, onChange: onChangeProp = (_value)=>{}, onFocus: onFocus = (_event_0)=>{}, selectProps: /* eslint-enable @repo/internal/react/use-noop */ selectProps = {}, shouldShowCalendarButton: shouldShowCalendarButton, spacing: spacing = 'default', locale: propLocale = 'en-US', value: propValue, isOpen: isOpenProp, maxDate: maxDate, minDate: minDate, weekStartDay: weekStartDay, formatDisplayLabel: formatDisplayLabel, testId: testId, 'aria-describedby': ariaDescribedBy, placeholder: placeholder, nextMonthLabel: nextMonthLabel, previousMonthLabel: previousMonthLabel, ...rest } = props;
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(defaultIsOpen);
    const [__0, setIsFocused] = (0, $cozmU.useState)(false);
    const [clearingFromIcon, setClearingFromIcon] = (0, $cozmU.useState)(false);
    const [selectInputValue, setSelectInputValue] = (0, $cozmU.useState)(selectProps.inputValue);
    const [value, setValue] = (0, $cozmU.useState)(propValue || defaultValue);
    const [calendarValue, setCalendarValue] = (0, $cozmU.useState)(propValue || defaultValue || (0, $6bH7j.getShortISOString)(new Date()));
    const [l10n, setL10n] = (0, $cozmU.useState)((0, $3vMGL.createLocalizationProvider)(propLocale));
    const [locale, setLocale] = (0, $cozmU.useState)(propLocale);
    const [shouldSetFocusOnCurrentDay, setShouldSetFocusOnCurrentDay] = (0, $cozmU.useState)(false);
    const [isKeyDown, setIsKeyDown] = (0, $cozmU.useState)(false);
    const isTopLayerEnabled = (0, $iDrrr.fg)('platform-dst-top-layer');
    const { MenuPortal: customMenuPortal, ...selectComponentOverrides } = selectProps.components ?? {};
    const { menuRenderMode: _menuRenderMode, ...selectPropsWithoutMenuRenderMode } = selectProps;
    const selectPropsForSelect = isTopLayerEnabled ? selectPropsWithoutMenuRenderMode : selectProps;
    const [wasOpenedFromCalendarButton, setWasOpenedFromCalendarButton] = (0, $cozmU.useState)(false);
    const additionalInsideElementRefs = (0, $cozmU.useMemo)(()=>[
            calendarButtonRef
        ], [
        calendarButtonRef
    ]); // Hack to force update: https://legacy.reactjs.org/docs/hooks-faq.html#is-there-something-like-forceupdate
    const [, forceUpdate] = (0, $cozmU.useReducer)((x)=>!x, true);
    const onChangePropWithAnalytics = (0, $7r5Hr.usePlatformLeafEventHandler)({
        fn: onChangeProp,
        action: 'selectedDate',
        actionSubject: 'datePicker',
        ...$c67bd6933458bbbd$var$analyticsAttributes
    });
    if (propLocale !== locale) {
        setL10n((0, $3vMGL.createLocalizationProvider)(propLocale));
        setLocale(propLocale);
    }
    (0, $cozmU.useEffect)(()=>{
        // Only move focus when the dedicated calendar button opened the menu.
        if (!isKeyDown) return;
        if (isOpen && wasOpenedFromCalendarButton) {
            setIsKeyDown(false); // Focus on the first button within the calendar
            calendarRef?.current?.querySelector('button')?.focus();
        }
    }, [
        isKeyDown,
        calendarRef,
        isOpen,
        wasOpenedFromCalendarButton
    ]);
    const getValue = ()=>propValue ?? value;
    const getIsOpen = ()=>isOpenProp ?? isOpen;
    const onCalendarChange = ({ iso: iso })=>{
        setCalendarValue((0, $c1tjA.getParsedISO)({
            iso: iso
        }));
    };
    const onCalendarSelect = ({ iso: iso_0 })=>{
        setSelectInputValue('');
        setIsOpen(false);
        setCalendarValue(iso_0);
        setValue(iso_0);
        setWasOpenedFromCalendarButton(false);
        onChangePropWithAnalytics(iso_0); // When using top-layer, PopupContent handles focus restoration automatically
        // on close based on the role. Only manually restore focus for the legacy path.
        if (!(0, $iDrrr.fg)('platform-dst-top-layer')) {
            if (wasOpenedFromCalendarButton) calendarButtonRef.current?.focus();
            else {
                const innerCombobox = containerRef?.current?.querySelector('[role="combobox"]');
                innerCombobox?.focus();
            }
        }
        setIsOpen(false);
    };
    const onInputClick = ()=>{
        if (!isDisabled && !getIsOpen()) {
            setIsOpen(true);
            setWasOpenedFromCalendarButton(false);
        }
    };
    const onContainerBlur = (event)=>{
        const newlyFocusedElement = event.relatedTarget;
        isPointerInteractionRef.current = false;
        if (!containerRef?.current?.contains(newlyFocusedElement)) {
            setIsOpen(false);
            setShouldSetFocusOnCurrentDay(false);
            setWasOpenedFromCalendarButton(false);
            onBlur(event);
        }
    };
    const onContainerFocus = ()=>{
        setShouldSetFocusOnCurrentDay(false);
    };
    const onSelectBlur = (event_0)=>{
        const newlyFocusedElement_0 = event_0.relatedTarget;
        if (clearingFromIcon) // Don't close menu if blurring after the user has clicked clear
        setClearingFromIcon(false);
        else if (!containerRef?.current?.contains(newlyFocusedElement_0)) {
            // Don't close menu if focus is staying within the date picker's
            // container. Makes keyboard accessibility of calendar possible
            setIsOpen(false);
            setIsFocused(false);
            setWasOpenedFromCalendarButton(false);
        }
    };
    const onSelectFocus = (event_1)=>{
        const value_0 = getValue();
        if (clearingFromIcon) // Don't open menu if focussing after the user has clicked clear
        setClearingFromIcon(false);
        else {
            // Opening an auto popover during pointer focus allows the matching pointerup
            // to immediately light-dismiss it. Let the subsequent click open it instead.
            if (!(0, $iDrrr.fg)('platform-dst-top-layer') || !isPointerInteractionRef.current) // Don't open when focused into via keyboard if the calendar button is present
            setIsOpen(!shouldShowCalendarButton);
            setCalendarValue(value_0);
            setIsFocused(true);
            setWasOpenedFromCalendarButton(false);
        }
        onFocus(event_1);
    };
    const onTextInput = (event_2)=>{
        const inputValue = event_2.target.value;
        if (inputValue) {
            const parsed = (0, $lzTfS.parseDate)(inputValue, {
                parseInputValue: rest?.parseInputValue,
                dateFormat: rest?.dateFormat,
                l10n: l10n
            }); // Only try to set the date if we have month & day
            if (parsed && (0, $esV19.default)(parsed)) // We format the parsed date to YYYY-MM-DD here because
            // this is the format expected by the @atlaskit/calendar component
            setCalendarValue((0, $6bH7j.getShortISOString)(parsed));
        }
        setIsOpen(true);
        setWasOpenedFromCalendarButton(false);
    };
    const onInputKeyDown = (event_3)=>{
        const value_1 = getValue();
        const keyPressed = event_3.key.toLowerCase(); // If the input is focused and the calendar is not visible, handle space and enter clicks
        if (!isOpen && (keyPressed === 'enter' || keyPressed === ' ')) {
            setIsOpen(true);
            setWasOpenedFromCalendarButton(false);
        }
        const shouldDeferEscapeHandling = event_3.key === 'Escape' && isTopLayerEnabled && getIsOpen();
        if (shouldDeferEscapeHandling) {
            // Select owns Escape cancellation and dismissal for its default top-layer popup.
            // Defer DatePicker's focus and state cleanup until the menu has closed.
            const focusRestorationTarget = wasOpenedFromCalendarButton ? calendarButtonRef.current : containerRef.current?.querySelector('[role="combobox"]') ?? null;
            focusRestorationTargetRef.current = event_3.defaultPrevented ? null : focusRestorationTarget;
            return;
        }
        switch(keyPressed){
            case 'escape':
                // Restore focus because it may have moved from the input into the calendar.
                if (wasOpenedFromCalendarButton) calendarButtonRef.current?.focus();
                else {
                    const innerCombobox_0 = containerRef?.current?.querySelector('[role="combobox"]');
                    innerCombobox_0?.focus();
                }
                setIsOpen(false);
                setShouldSetFocusOnCurrentDay(false);
                setWasOpenedFromCalendarButton(false);
                break;
            case 'backspace':
            case 'delete':
                {
                    const inputCount = 0;
                    if (value_1 && event_3.target instanceof HTMLInputElement && event_3.target.value.length <= inputCount) {
                        // If being cleared from keyboard, don't change behaviour
                        setClearingFromIcon(false);
                        setValue('');
                    }
                    break;
                }
            case 'enter':
                if (!isOpen) return;
                 // Prevent form submission when a date is selected
                // using enter. See https://product-fabric.atlassian.net/browse/DSP-2501
                // for more details.
                event_3.preventDefault();
                if (!(0, $goKry.isDateDisabled)(calendarValue, {
                    disabled: disabled
                })) {
                    // Get a safe `calendarValue` in case the value exceeds the maximum
                    // allowed by ISO 8601
                    const safeCalendarValue = (0, $jchtB.getSafeCalendarValue)(calendarValue);
                    const valueChanged = safeCalendarValue !== value_1;
                    setSelectInputValue('');
                    setIsOpen(false);
                    setValue(safeCalendarValue);
                    setCalendarValue(safeCalendarValue);
                    setWasOpenedFromCalendarButton(wasOpenedFromCalendarButton);
                    if (valueChanged) onChangePropWithAnalytics(safeCalendarValue);
                }
                break;
            case 'arrowdown':
            case 'arrowup':
                if (!shouldSetFocusOnCurrentDay) {
                    setIsOpen(true);
                    setShouldSetFocusOnCurrentDay(true);
                }
                break;
            default:
                break;
        }
    };
    const onMenuClose = ()=>{
        const focusTarget = focusRestorationTargetRef.current;
        focusRestorationTargetRef.current = null;
        if ((0, $iDrrr.fg)('platform-dst-top-layer') && focusTarget) {
            focusTarget.focus();
            setIsOpen(false);
            setShouldSetFocusOnCurrentDay(false);
            setWasOpenedFromCalendarButton(false);
        }
        selectProps.onMenuClose?.();
    };
    const onCalendarButtonKeyDown = (e)=>{
        // Don't allow an arrow up or down to open the menu, since the input key
        // down handler is actually on the parent.
        if (e.type === 'keydown' && (e.key === 'ArrowDown' || e.key === 'ArrowUp')) e.stopPropagation();
         // We want to stop this from triggering other keydown events, particularly
        // for space and enter presses. Otherwise, it opens and then closes
        // immediately.
        if (e.type === 'keydown' && (e.key === ' ' || e.key === 'Enter')) {
            e.stopPropagation();
            setIsKeyDown(true);
            setWasOpenedFromCalendarButton(true);
        }
    }; // This event handler is triggered from both keydown and click. It's weird.
    const onCalendarButtonClick = (e_0)=>{
        if (!getIsOpen() && (0, $iDrrr.fg)('platform-dst-top-layer')) setIsKeyDown(true);
        setIsOpen((isOpen_0)=>{
            if (isOpen_0) {
                props.selectProps?.onMenuClose?.();
                return false;
            } else {
                props.selectProps?.onMenuOpen?.();
                return true;
            }
        });
        setWasOpenedFromCalendarButton(true);
        e_0.stopPropagation();
    };
    const onClear = ()=>{
        setValue('');
        setCalendarValue(defaultValue || (0, $6bH7j.getShortISOString)(new Date()));
        if (!hideIcon) setClearingFromIcon(true);
        onChangePropWithAnalytics('');
    }; // `unknown` is used because `value` is unused so it does not matter.
    const onSelectChange = (_value_0, action)=>{
        // Used for native clear event in React Select
        // Triggered when clicking ClearIndicator or backspace with no value
        if (action.action === 'clear') onClear();
    };
    const handleSelectInputChange = (selectInputValue_0, actionMeta)=>{
        if (selectProps.onInputChange) selectProps.onInputChange(selectInputValue_0, actionMeta);
        setSelectInputValue(selectInputValue_0);
    };
    const getContainerRef = (0, $cozmU.useCallback)((ref)=>{
        const oldRef = containerRef.current;
        containerRef.current = ref; // Cause a re-render if we're getting the container ref for the first time
        // as the layered menu requires it for dimension calculation
        if (oldRef == null && ref != null) forceUpdate();
    }, [
        containerRef
    ]);
    const getterValue = getValue();
    let actualSelectInputValue;
    actualSelectInputValue = selectInputValue;
    const menuIsOpen = getIsOpen() && !isDisabled;
    const showClearIndicator = Boolean((getterValue || selectInputValue) && !hideIcon);
    let clearIndicator = (props_0)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            xcss: $c67bd6933458bbbd$var$styles.dropdownIndicatorStyles,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)(Icon, {
                ...props_0
            })
        });
    const dropDownIcon = appearance === 'subtle' || hideIcon || showClearIndicator ? null : clearIndicator;
    const valueId = (0, $6JrSr.useId)();
    const SingleValue = (0, $ep7Ex.makeSingleValue)({
        id: valueId,
        lang: propLocale
    });
    const selectComponents = {
        ...isTopLayerEnabled ? selectComponentOverrides : selectProps.components,
        DropdownIndicator: shouldShowCalendarButton ? (0, $2DcxV.EmptyComponent) : dropDownIcon,
        // Only use this new container component if the calendar button is shown.
        // Otherwise, it throws errors downstream for some reason
        ...shouldShowCalendarButton ? {
            IndicatorsContainer: (props_1)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $dDPKN.IndicatorsContainer), {
                    ...props_1,
                    showClearIndicator: showClearIndicator
                })
        } : {},
        Menu: (0, $iDrrr.fg)('platform-dst-top-layer') ? (0, $cME0o.MenuTopLayer) : (0, $dAzeP.Menu),
        SingleValue: SingleValue,
        ...!showClearIndicator && {
            ClearIndicator: (0, $2DcxV.EmptyComponent)
        }
    };
    const { styles: selectStyles = {} } = selectProps;
    const disabledStyle = isDisabled ? {
        pointerEvents: 'none',
        color: "var(--ds-icon-disabled, #080F214A)"
    } : {};
    const calendarProps = {
        calendarContainerRef: containerRef.current,
        calendarDisabled: disabled,
        calendarDisabledDateFilter: disabledDateFilter,
        calendarMaxDate: maxDate,
        calendarMinDate: minDate,
        calendarRef: calendarRef,
        calendarValue: getterValue && (0, $6bH7j.getShortISOString)((0, $k5sGX.default)(getterValue)),
        calendarView: calendarValue,
        onCalendarChange: onCalendarChange,
        onCalendarSelect: onCalendarSelect,
        calendarLocale: locale,
        calendarWeekStartDay: weekStartDay ?? ((0, $iDrrr.fg)('platform-dst-locale-week-start-day') ? l10n.getFirstDayOfWeek() : undefined),
        shouldSetFocusOnCurrentDay: shouldSetFocusOnCurrentDay,
        /**
    * This overrides the inner wrapper the Calendar.
    * @private Please use this with extreme caution, this API may be changed in the future.
    */ menuInnerWrapper: props?.menuInnerWrapper
    };
    const mergedStyles = (0, $1TlML.mergeStyles)(selectStyles, {
        control: (base)=>({
                ...base,
                ...disabledStyle
            }),
        indicatorsContainer: (base_0)=>({
                ...base_0,
                paddingLeft: "var(--ds-space-025, 2px)",
                paddingRight: "var(--ds-space-075, 6px)"
            })
    });
    const initialValue = getterValue ? {
        label: (0, $7P40I.formatDate)(getterValue, {
            formatDisplayLabel: formatDisplayLabel,
            dateFormat: rest?.dateFormat,
            l10n: l10n
        }),
        value: getterValue
    } : null; // `label` takes precedence of the `inputLabel`
    const fullopenCalendarLabel = label || inputLabel ? `${label || inputLabel}, ${openCalendarLabel}` : openCalendarLabel;
    const openCalendarLabelId = `open-calendar-label--${(0, $6JrSr.useId)()}`;
    return /*#__PURE__*/ (0, $8aG6j.jsxs)("div", {
        ...innerProps,
        "data-testid": testId && `${testId}--container`,
        onBlur: onContainerBlur,
        // any focus they move is safe to treat as non-pointer focus. Capture also guarantees cleanup
        // when a descendant stops the bubbling click.
        onClickCapture: ()=>{
            isPointerInteractionRef.current = false;
        },
        onFocus: onContainerFocus,
        onClick: onInputClick,
        onInput: onTextInput,
        onKeyDown: onInputKeyDown,
        onPointerCancelCapture: ()=>{
            isPointerInteractionRef.current = false;
        },
        onPointerDownCapture: ()=>{
            isPointerInteractionRef.current = true;
        },
        ref: getContainerRef,
        role: "presentation",
        className: (0, $hekY6.default)([
            $c67bd6933458bbbd$var$styles.pickerContainerStyle
        ]),
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)("input", {
                name: name,
                type: "hidden",
                value: getterValue,
                "data-testid": testId && `${testId}--input`
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6wGOF.default), {
                appearance: appearance,
                "aria-describedby": ariaDescribedBy ? `${ariaDescribedBy} ${valueId}` : valueId,
                label: label || undefined,
                autoFocus: autoFocus,
                clearControlLabel: clearControlLabel,
                closeMenuOnSelect: true,
                enableAnimation: false,
                inputId: id,
                inputValue: actualSelectInputValue,
                isDisabled: isDisabled,
                isRequired: isRequired,
                menuIsOpen: menuIsOpen,
                onBlur: onSelectBlur,
                onChange: onSelectChange,
                onFocus: onSelectFocus,
                onInputChange: handleSelectInputChange,
                placeholder: (0, $3YIJ0.getPlaceholder)({
                    placeholder: placeholder,
                    l10n: l10n
                }),
                // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
                styles: mergedStyles,
                value: initialValue,
                ...selectPropsForSelect,
                additionalInsideElementRefs: isTopLayerEnabled ? additionalInsideElementRefs : undefined,
                onMenuClose: onMenuClose,
                // up when you alter some of the properties in the `selectComponents`
                // object. These errors are still present, and I suspect have always
                // been present, without changing the unrelated code. Ignoring as the
                // component still works as expected despite this error. And also
                // because the select refresh team may solve it later.
                components: selectComponents,
                // selectProps or not and what wil be overwritten
                isClearable: true,
                isInvalid: isInvalid,
                spacing: spacing,
                testId: testId,
                calendarContainerRef: calendarProps.calendarContainerRef,
                calendarDisabled: calendarProps.calendarDisabled,
                calendarDisabledDateFilter: calendarProps.calendarDisabledDateFilter,
                calendarLocale: calendarProps.calendarLocale,
                calendarMaxDate: calendarProps.calendarMaxDate,
                calendarMinDate: calendarProps.calendarMinDate,
                calendarRef: calendarProps.calendarRef,
                calendarValue: calendarProps.calendarValue,
                calendarView: calendarProps.calendarView,
                calendarWeekStartDay: calendarProps.calendarWeekStartDay,
                nextMonthLabel: nextMonthLabel,
                onCalendarChange: calendarProps.onCalendarChange,
                onCalendarSelect: calendarProps.onCalendarSelect,
                previousMonthLabel: previousMonthLabel,
                shouldSetFocusOnCurrentDay: calendarProps.shouldSetFocusOnCurrentDay,
                menuInnerWrapper: calendarProps.menuInnerWrapper
            }),
            shouldShowCalendarButton && !isDisabled ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                xcss: (0, $w6R6I.cx)($c67bd6933458bbbd$var$styles.iconContainerStyles, getterValue && !hideIcon ? $c67bd6933458bbbd$var$styles.iconSpacingWithClearButtonStyles : $c67bd6933458bbbd$var$styles.iconSpacingWithoutClearButtonStyles),
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1sCHt.default), {
                    appearance: "subtle",
                    label: !inputLabelId ? fullopenCalendarLabel : openCalendarLabel,
                    "aria-labelledby": inputLabelId ? `${inputLabelId} ${openCalendarLabelId}` : undefined,
                    id: openCalendarLabelId,
                    icon: (iconProps)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($824lD))), {
                            ...iconProps,
                            color: "var(--ds-icon, #292A2E)"
                        }),
                    onClick: onCalendarButtonClick,
                    onKeyDown: onCalendarButtonKeyDown,
                    ref: calendarButtonRef,
                    testId: testId && `${testId}--open-calendar-button`
                })
            }) : null
        ]
    });
});
var $c67bd6933458bbbd$export$2e2bcd8739ae039 = $c67bd6933458bbbd$var$DatePicker;
module.exports["default"] = $c67bd6933458bbbd$export$2e2bcd8739ae039;

});

parcelRegister("2DcxV", function(module, exports) {
/**
 * This component is used to hide portions of Select component.
 */ const $15ef0256511c01c4$export$5e30e9a24d6c1203 = ()=>null;
module.exports["EmptyComponent"] = $15ef0256511c01c4$export$5e30e9a24d6c1203;

});

parcelRegister("7P40I", function(module, exports) {
/**
 * Everything in this file is to smooth out the migration of the new date picker
 * (https://product-fabric.atlassian.net/browse/DSP-20682). When that ticket is
 * complete, all of these functions will ilkely be merged back into the date
 * picker. Please do not pre-optimize and put these back into the date picker
 * unless you are working on the DTP Refresh and you have a good reason to do
 * so, thank you!
 *
 * All variables within the `di` objects are dependency injections. They should
 * be read from within the component at the end of the day. But because we are
 * extracting them, we have to inject them in every place manually. When we
 * re-introduce them to the components, we can likely remove the `di` variables
 * and instead use internal variables.
 *
 * If component _only_ has injected variables, it is fully internal and was
 * broken out to be it's own function.
 */ // oxlint-disable-next-line @atlassian/no-restricted-imports

var $f6RxU = parcelRequire("f6RxU");

var $k5sGX = parcelRequire("k5sGX");


var $5NE0I = parcelRequire("5NE0I");


var $78xYN = parcelRequire("78xYN");

const $1320985d4abf5be3$export$3ae94a2503e890a1 = (value, di)=>{
    const { formatDisplayLabel: formatDisplayLabel, dateFormat: dateFormat, l10n: l10n } = di;
    if (formatDisplayLabel) return formatDisplayLabel(value, dateFormat || (0, $5NE0I.defaultDateFormat));
    const date = (0, $k5sGX.default)(value);
    return dateFormat ? (0, $f6RxU.default)(date, (0, $78xYN.convertTokens)(dateFormat)) : l10n.formatDate(date);
};
module.exports["formatDate"] = $1320985d4abf5be3$export$3ae94a2503e890a1;

});

parcelRegister("5NE0I", function(module, exports) {
const $f78c70927ab65aa7$export$75032c84f56650eb = 'YYYY/MM/DD';
module.exports["defaultDateFormat"] = $f78c70927ab65aa7$export$75032c84f56650eb;

});

parcelRegister("78xYN", function(module, exports) {
// https://github.com/date-fns/date-fns-upgrade/blob/master/src/v2/convertTokens/index.ts
const $8aa1b22faba44901$var$tokensMap = {
    // 'D MMMM': '',
    // 'Do MMMM': '',
    // 'DD MMMM': '',
    M: 'L',
    Mo: 'Mo',
    MM: 'LL',
    MMM: 'LLL',
    MMMM: 'LLLL',
    Q: 'q',
    Qo: 'qo',
    D: 'd',
    Do: 'do',
    DD: 'dd',
    DDD: 'D',
    DDDo: 'Do',
    DDDD: 'DDD',
    d: 'i',
    do: 'io',
    dd: 'iiiiii',
    ddd: 'iii',
    dddd: 'iiii',
    A: 'a',
    a: 'a',
    aa: 'aaaa',
    E: 'i',
    W: 'I',
    Wo: 'Io',
    WW: 'II',
    YY: 'yy',
    YYYY: 'yyyy',
    GG: 'RR',
    GGGG: 'RRRR',
    H: 'H',
    HH: 'HH',
    h: 'h',
    hh: 'hh',
    m: 'm',
    mm: 'mm',
    s: 's',
    ss: 'ss',
    S: 'S',
    SS: 'SS',
    SSS: 'SSS',
    Z: 'xxx',
    ZZ: 'xx',
    X: 't',
    x: 'T'
};
const $8aa1b22faba44901$var$v1tokens = Object.keys($8aa1b22faba44901$var$tokensMap).sort().reverse();
const $8aa1b22faba44901$var$tokensRegExp = new RegExp(// v1 escape string (unsure the purpose of post-pipe capture group)
"(\\[[^\\[]*\\])|(\\\\)?('.+'|" + // All v1 tokens
$8aa1b22faba44901$var$v1tokens.join('|') + '|.)', 'g');
function $8aa1b22faba44901$export$4d5430175be73d45(format) {
    const tokensCaptures = format.match($8aa1b22faba44901$var$tokensRegExp);
    if (!tokensCaptures) return format;
    return tokensCaptures.reduce((parsed, tokenString, index)=>{
        const v2token = $8aa1b22faba44901$var$tokensMap[tokenString];
        if (!v2token) {
            const escapedCaptures = tokenString.match(/^\[(.+)\]$/);
            if (escapedCaptures) parsed.escapedTextBuffer.push(escapedCaptures[1]);
            else parsed.escapedTextBuffer.push(tokenString);
        }
        const endOfString = index === tokensCaptures.length - 1;
        if (parsed.escapedTextBuffer.length && (v2token || endOfString)) {
            // This allows double parentheses to be rendered correctly
            // according to date-fns's spec.
            // https://date-fns.org/v2.29.3/docs/format
            //
            // We have to keep the single quote and then remove it because
            // browser support for lookahead/behind is low and causes breaking
            // errors (HOT-104152)
            const filteredEscapedTextBuffer = parsed.escapedTextBuffer.map((token)=>token[0] === "'" && token.slice(-1) === "'" ? token.slice(1, -1) : token).filter((token)=>token !== "'").join('');
            parsed.formatBuffer.push(`'${filteredEscapedTextBuffer}'`);
            parsed.escapedTextBuffer = [];
        }
        if (v2token) parsed.formatBuffer.push(v2token);
        return parsed;
    }, {
        formatBuffer: [],
        escapedTextBuffer: []
    }).formatBuffer.join('');
}
module.exports["convertTokens"] = $8aa1b22faba44901$export$4d5430175be73d45;

});

parcelRegister("c1tjA", function(module, exports) {
/**
 * Everything in this file is to smooth out the migration of the new date picker
 * (https://product-fabric.atlassian.net/browse/DSP-20682). When that ticket is
 * complete, all of these functions will ilkely be merged back into the date
 * picker. Please do not pre-optimize and put these back into the date picker
 * unless you are working on the DTP Refresh and you have a good reason to do
 * so, thank you!
 *
 * All variables within the `di` objects are dependency injections. They should
 * be read from within the component at the end of the day. But because we are
 * extracting them, we have to inject them in every place manually. When we
 * re-introduce them to the components, we can likely remove the `di` variables
 * and instead use internal variables.
 *
 * If component _only_ has injected variables, it is fully internal and was
 * broken out to be it's own function.
 */ // oxlint-disable-next-line @atlassian/no-restricted-imports

var $dFOvD = parcelRequire("dFOvD");


var $dFfyu = parcelRequire("dFfyu");

const $10b2801952722091$export$38db26406d1a1ee2 = (di)=>{
    const { iso: iso } = di;
    const [year, month, date] = iso.split('-');
    let newIso = iso;
    const parsedDate = parseInt(date, 10);
    const parsedMonth = parseInt(month, 10);
    const parsedYear = parseInt(year, 10);
    const lastDayInMonth = (0, $dFOvD.default)(new Date(parsedYear, parsedMonth - 1 // This needs to be -1, because the Date constructor expects an index of the given month
    )).getDate();
    if (lastDayInMonth < parsedDate) newIso = `${parsedYear}-${(0, $dFfyu.padToTwo)(parsedMonth)}-${(0, $dFfyu.padToTwo)(lastDayInMonth)}`;
    else newIso = `${parsedYear}-${(0, $dFfyu.padToTwo)(parsedMonth)}-${(0, $dFfyu.padToTwo)(parsedDate)}`;
    return newIso;
};
module.exports["getParsedISO"] = $10b2801952722091$export$38db26406d1a1ee2;

});

parcelRegister("dFOvD", function(module, exports) {
$parcel$export(module.exports, "default", () => $9f4648cab1450763$export$2e2bcd8739ae039);

var $dkBOe = parcelRequire("dkBOe");


var $3yGK6 = parcelRequire("3yGK6");

function $9f4648cab1450763$export$2e2bcd8739ae039(dirtyDate) {
    (0, $3yGK6.default)(1, arguments);
    var date = (0, $dkBOe.default)(dirtyDate);
    var month = date.getMonth();
    date.setFullYear(date.getFullYear(), month + 1, 0);
    date.setHours(0, 0, 0, 0);
    return date;
}

});

parcelRegister("dFfyu", function(module, exports) {
function $9f4ac43d2e8abc6a$export$a7de57e5b672ccdb(number) {
    return number <= 99 ? `0${number}`.slice(-2) : `${number}`;
}
module.exports["padToTwo"] = $9f4ac43d2e8abc6a$export$a7de57e5b672ccdb;

});

parcelRegister("3YIJ0", function(module, exports) {
/**
 * Everything in this file is to smooth out the migration of the new date picker
 * (https://product-fabric.atlassian.net/browse/DSP-20682). When that ticket is
 * complete, all of these functions will ilkely be merged back into the date
 * picker. Please do not pre-optimize and put these back into the date picker
 * unless you are working on the DTP Refresh and you have a good reason to do
 * so, thank you!
 *
 * All variables within the `di` objects are dependency injections. They should
 * be read from within the component at the end of the day. But because we are
 * extracting them, we have to inject them in every place manually. When we
 * re-introduce them to the components, we can likely remove the `di` variables
 * and instead use internal variables.
 *
 * If component _only_ has injected variables, it is fully internal and was
 * broken out to be it's own function.
 */ // oxlint-disable-next-line @atlassian/no-restricted-imports

var $6YTmv = parcelRequire("6YTmv");

const $91124c7d4521d8af$export$d3f5c5e0a5023fa0 = (di)=>{
    const { placeholder: placeholder, l10n: l10n } = di;
    return placeholder || l10n.formatDate((0, $6YTmv.placeholderDatetime));
};
module.exports["getPlaceholder"] = $91124c7d4521d8af$export$d3f5c5e0a5023fa0;

});

parcelRegister("6YTmv", function(module, exports) {
// This date was chosen to clearly show date and time formats (day > 12)
// e.g. 18/02/1993 vs. 2/18/1993 and 1:00 PM vs 13:00
const $793e1f5a2758a99c$export$fff8babee5abe3e2 = new Date(1993, 1, 18, 13);
module.exports["placeholderDatetime"] = $793e1f5a2758a99c$export$fff8babee5abe3e2;

});

parcelRegister("jchtB", function(module, exports) {
// oxlint-disable-next-line @atlassian/no-restricted-imports

var $6bH7j = parcelRequire("6bH7j");

function $719f2b69dfc70e7c$export$ff525416014fb67d(calendarValue) {
    // If `calendarValue` has a year that is greater than 9999, default to
    // today's date
    const yearIsOverLimit = calendarValue.match(/^\d{5,}/);
    if (yearIsOverLimit) return (0, $6bH7j.getShortISOString)(new Date());
    return calendarValue;
}
module.exports["getSafeCalendarValue"] = $719f2b69dfc70e7c$export$ff525416014fb67d;

});

parcelRegister("6bH7j", function(module, exports) {
// oxlint-disable-next-line @atlassian/no-restricted-imports

var $f6RxU = parcelRequire("f6RxU");


var $78xYN = parcelRequire("78xYN");

function $0854920bdb032d57$export$77d5bc49fed7ef14(date) {
    return (0, $f6RxU.default)(date, (0, $78xYN.convertTokens)('YYYY-MM-DD'));
}
module.exports["getShortISOString"] = $0854920bdb032d57$export$77d5bc49fed7ef14;

});

parcelRegister("dDPKN", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $l9ukq = parcelRequire("l9ukq");

const $0c8e523c19b51055$var$styles = {
    calendarButtonInclusionStyles: "_0GTcwRVa5s",
    calendarButtonOnlyInclusionStyles: "_0GTcwRNHnM"
};
const $0c8e523c19b51055$export$d0ffd7e649cab6f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(10);
    let rest;
    let showClearIndicator;
    if ($[0] !== t0) {
        ({ showClearIndicator: showClearIndicator, ...rest } = t0);
        $[0] = t0;
        $[1] = rest;
        $[2] = showClearIndicator;
    } else {
        rest = $[1];
        showClearIndicator = $[2];
    }
    const t1 = showClearIndicator ? $0c8e523c19b51055$var$styles.calendarButtonInclusionStyles : $0c8e523c19b51055$var$styles.calendarButtonOnlyInclusionStyles;
    let t2;
    if ($[3] !== t1) {
        t2 = (0, $hekY6.default)([
            t1
        ]);
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== rest) {
        t3 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $l9ukq.components).IndicatorsContainer, {
            ...rest
        });
        $[5] = rest;
        $[6] = t3;
    } else t3 = $[6];
    let t4;
    if ($[7] !== t2 || $[8] !== t3) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            className: t2,
            children: t3
        });
        $[7] = t2;
        $[8] = t3;
        $[9] = t4;
    } else t4 = $[9];
    return t4;
} : ({ showClearIndicator: showClearIndicator, ...rest })=>/*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        className: (0, $hekY6.default)([
            showClearIndicator ? $0c8e523c19b51055$var$styles.calendarButtonInclusionStyles : $0c8e523c19b51055$var$styles.calendarButtonOnlyInclusionStyles
        ]),
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $l9ukq.components).IndicatorsContainer, {
            ...rest
        })
    });
module.exports["IndicatorsContainer"] = $0c8e523c19b51055$export$d0ffd7e649cab6f;

});

parcelRegister("goKry", function(module, exports) {
/**
 * Everything in this file is to smooth out the migration of the new date picker
 * (https://product-fabric.atlassian.net/browse/DSP-20682). When that ticket is
 * complete, all of these functions will ilkely be merged back into the date
 * picker. Please do not pre-optimize and put these back into the date picker
 * unless you are working on the DTP Refresh and you have a good reason to do
 * so, thank you!
 *
 * All variables within the `di` objects are dependency injections. They should
 * be read from within the component at the end of the day. But because we are
 * extracting them, we have to inject them in every place manually. When we
 * re-introduce them to the components, we can likely remove the `di` variables
 * and instead use internal variables.
 *
 * If component _only_ has injected variables, it is fully internal and was
 * broken out to be it's own function.
 */ // oxlint-disable-next-line @atlassian/no-restricted-imports
const $24a203ae40efce07$export$d38e7e283938128c = (date, di)=>{
    const { disabled: disabled } = di;
    return disabled.indexOf(date) > -1;
};
module.exports["isDateDisabled"] = $24a203ae40efce07$export$d38e7e283938128c;

});

parcelRegister("dAzeP", function(module, exports) {
/* menu.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $esV19 = parcelRequire("esV19");

var $k5sGX = parcelRequire("k5sGX");


var $buG8Z = parcelRequire("buG8Z");


var $1ZDKy = parcelRequire("1ZDKy");


var $a0UNJ = parcelRequire("a0UNJ");

function $3c56044decc29caa$var$getValidDate(isos) {
    return isos.reduce((acc, iso)=>{
        const date = (0, $k5sGX.default)(iso);
        return (0, $esV19.default)(date) ? {
            day: date.getDate(),
            month: date.getMonth() + 1,
            year: date.getFullYear()
        } : acc;
    }, {});
}
const $3c56044decc29caa$var$menuStyles = null; /**
                          * This is the menu used in the select of the date picker.
                          */ 
const $3c56044decc29caa$export$d9b273488cd8ce6f = ({ selectProps: selectProps, innerProps: innerProps })=>{
    const { calendarValue: calendarValue, calendarView: calendarView, menuInnerWrapper: MenuInnerWrapper } = selectProps;
    const { day: day, month: month, year: year } = $3c56044decc29caa$var$getValidDate([
        calendarValue,
        calendarView
    ]);
    const onMenuMouseDown = (event)=>{
        if (event.button !== 0) return;
        event.stopPropagation();
        event.preventDefault();
    };
    const Wrapper = typeof MenuInnerWrapper === 'function' ? MenuInnerWrapper : (0, $cozmU.Fragment);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1ZDKy.Layering), {
        isDisabled: false,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $a0UNJ.default), {
            inputValue: selectProps.inputValue,
            containerRef: selectProps.calendarContainerRef,
            content: /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                ...innerProps,
                onMouseDown: onMenuMouseDown,
                className: (0, $hekY6.default)([
                    "_0bjKvD8fU6 _4bt5LAnQyn _2WAcuGnQyn _42Yu6BPvK5 _0KLXruoI2d _2OUyjtGk8v"
                ]),
                children: /*#__PURE__*/ (0, $8aG6j.jsx)(Wrapper, {
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $buG8Z.default), {
                        day: day,
                        month: month,
                        year: year,
                        disabled: selectProps.calendarDisabled,
                        disabledDateFilter: selectProps.calendarDisabledDateFilter,
                        minDate: selectProps.calendarMinDate,
                        maxDate: selectProps.calendarMaxDate,
                        nextMonthLabel: selectProps.nextMonthLabel,
                        onChange: selectProps.onCalendarChange,
                        onSelect: selectProps.onCalendarSelect,
                        previousMonthLabel: selectProps.previousMonthLabel,
                        ref: selectProps.calendarRef,
                        selected: [
                            selectProps.calendarValue
                        ],
                        shouldSetFocusOnCurrentDay: selectProps.shouldSetFocusOnCurrentDay,
                        locale: selectProps.calendarLocale,
                        testId: selectProps.testId && `${selectProps.testId}--calendar`,
                        weekStartDay: selectProps.calendarWeekStartDay
                    })
                })
            }),
            testId: selectProps.testId
        })
    });
};
module.exports["Menu"] = $3c56044decc29caa$export$d9b273488cd8ce6f;

});

parcelRegister("buG8Z", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $7r5Hr = parcelRequire("7r5Hr");


var $dpsRj = parcelRequire("dpsRj");


var $6JrSr = parcelRequire("6JrSr");


var $iMnC5 = parcelRequire("iMnC5");

var $dinVW = parcelRequire("dinVW");


var $CIxco = parcelRequire("CIxco");


var $4kl0X = parcelRequire("4kl0X");


var $RzcOF = parcelRequire("RzcOF");


var $2lTKb = parcelRequire("2lTKb");


var $669cn = parcelRequire("669cn");


var $lq3dZ = parcelRequire("lq3dZ");


var $2NGTx = parcelRequire("2NGTx");


var $3f826 = parcelRequire("3f826");


var $dEHey = parcelRequire("dEHey");

const $031e002627f496f2$var$styles = {
    box: "_3iDTPbvbI6 _20VacPYbGa"
};
const $031e002627f496f2$var$analyticsAttributes = {
    componentName: 'calendar',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $031e002627f496f2$var$InnerCalendar = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? function Calendar(t0, ref) {
    const $ = (0, $bDgLe.c)(142);
    const { day: day, defaultDay: t1, defaultMonth: t2, defaultPreviouslySelected: t3, defaultSelected: t4, defaultYear: t5, disabled: disabled, disabledDateFilter: disabledDateFilter, minDate: minDate, maxDate: maxDate, month: month, nextMonthLabel: nextMonthLabel, onBlur: t6, onChange: t7, onFocus: t8, onSelect: t9, previouslySelected: previouslySelected, previousMonthLabel: previousMonthLabel, selected: selected, shouldSetFocusOnCurrentDay: t10, today: today, locale: t11, year: year, analyticsContext: analyticsContext, weekStartDay: weekStartDay, testId: testId, className: className, style: style, tabIndex: t12 } = t0;
    const defaultDay = t1 === undefined ? 0 : t1;
    const defaultMonth = t2 === undefined ? 0 : t2;
    let t13;
    if ($[0] !== t3) {
        t13 = t3 === undefined ? [] : t3;
        $[0] = t3;
        $[1] = t13;
    } else t13 = $[1];
    const defaultPreviouslySelected = t13;
    let t14;
    if ($[2] !== t4) {
        t14 = t4 === undefined ? [] : t4;
        $[2] = t4;
        $[3] = t14;
    } else t14 = $[3];
    const defaultSelected = t14;
    const defaultYear = t5 === undefined ? 0 : t5;
    const onBlur = t6 === undefined ? (0, $dpsRj.default) : t6;
    const onChange = t7 === undefined ? (0, $dpsRj.default) : t7;
    const onFocus = t8 === undefined ? (0, $dpsRj.default) : t8;
    const onSelect = t9 === undefined ? (0, $dpsRj.default) : t9;
    const shouldSetFocusOnCurrentDay = t10 === undefined ? false : t10;
    const locale = t11 === undefined ? "en-US" : t11;
    const tabIndex = t12 === undefined ? 0 : t12;
    let t15;
    if ($[4] !== day || $[5] !== defaultDay || $[6] !== defaultMonth || $[7] !== defaultPreviouslySelected || $[8] !== defaultSelected || $[9] !== defaultYear || $[10] !== month || $[11] !== previouslySelected || $[12] !== selected || $[13] !== today || $[14] !== year) {
        t15 = {
            day: day,
            defaultDay: defaultDay,
            month: month,
            defaultMonth: defaultMonth,
            year: year,
            defaultYear: defaultYear,
            today: today,
            selected: selected,
            defaultSelected: defaultSelected,
            previouslySelected: previouslySelected,
            defaultPreviouslySelected: defaultPreviouslySelected
        };
        $[4] = day;
        $[5] = defaultDay;
        $[6] = defaultMonth;
        $[7] = defaultPreviouslySelected;
        $[8] = defaultSelected;
        $[9] = defaultYear;
        $[10] = month;
        $[11] = previouslySelected;
        $[12] = selected;
        $[13] = today;
        $[14] = year;
        $[15] = t15;
    } else t15 = $[15];
    const { day: t16, month: t17, year: t18, today: t19, selected: t20, previous: t21 } = (0, $2lTKb.default)(t15);
    const [dayValue, setDayValue] = t16;
    const [monthValue, setMonthValue] = t17;
    const [yearValue, setYearValue] = t18;
    const [todayValue] = t19;
    const [selectedValue, setSelectedValue] = t20;
    const [previouslySelectedValue, setPreviouslySelectedValue] = t21;
    const [shouldSetFocus, setShouldSetFocus] = (0, $cozmU.useState)(false);
    let t22;
    if ($[16] !== analyticsContext || $[17] !== onChange) {
        t22 = {
            fn: onChange,
            action: "changed",
            analyticsData: analyticsContext,
            ...$031e002627f496f2$var$analyticsAttributes
        };
        $[16] = analyticsContext;
        $[17] = onChange;
        $[18] = t22;
    } else t22 = $[18];
    const onChangeWithAnalytics = (0, $7r5Hr.usePlatformLeafEventHandler)(t22);
    let t23;
    if ($[19] !== dayValue || $[20] !== setDayValue) {
        t23 = [
            dayValue,
            setDayValue
        ];
        $[19] = dayValue;
        $[20] = setDayValue;
        $[21] = t23;
    } else t23 = $[21];
    let t24;
    if ($[22] !== monthValue || $[23] !== setMonthValue) {
        t24 = [
            monthValue,
            setMonthValue
        ];
        $[22] = monthValue;
        $[23] = setMonthValue;
        $[24] = t24;
    } else t24 = $[24];
    let t25;
    if ($[25] !== setYearValue || $[26] !== yearValue) {
        t25 = [
            yearValue,
            setYearValue
        ];
        $[25] = setYearValue;
        $[26] = yearValue;
        $[27] = t25;
    } else t25 = $[27];
    let t26;
    if ($[28] !== shouldSetFocus) {
        t26 = [
            shouldSetFocus,
            setShouldSetFocus
        ];
        $[28] = shouldSetFocus;
        $[29] = t26;
    } else t26 = $[29];
    let t27;
    if ($[30] !== onChangeWithAnalytics || $[31] !== t23 || $[32] !== t24 || $[33] !== t25 || $[34] !== t26) {
        t27 = {
            day: t23,
            month: t24,
            year: t25,
            shouldSetFocus: t26,
            onChange: onChangeWithAnalytics
        };
        $[30] = onChangeWithAnalytics;
        $[31] = t23;
        $[32] = t24;
        $[33] = t25;
        $[34] = t26;
        $[35] = t27;
    } else t27 = $[35];
    const { navigate: navigate, handleClickNextMonth: handleClickNextMonth, handleClickNextYear: handleClickNextYear, handleClickPrevMonth: handleClickPrevMonth, handleClickPrevYear: handleClickPrevYear } = (0, $2NGTx.default)(t27);
    let t28;
    if ($[36] !== analyticsContext || $[37] !== onSelect) {
        t28 = {
            fn: onSelect,
            action: "selected",
            analyticsData: analyticsContext,
            ...$031e002627f496f2$var$analyticsAttributes
        };
        $[36] = analyticsContext;
        $[37] = onSelect;
        $[38] = t28;
    } else t28 = $[38];
    const onSelectWithAnalytics = (0, $7r5Hr.usePlatformLeafEventHandler)(t28);
    let t29;
    if ($[39] !== dayValue || $[40] !== setDayValue) {
        t29 = [
            dayValue,
            setDayValue
        ];
        $[39] = dayValue;
        $[40] = setDayValue;
        $[41] = t29;
    } else t29 = $[41];
    let t30;
    if ($[42] !== monthValue || $[43] !== setMonthValue) {
        t30 = [
            monthValue,
            setMonthValue
        ];
        $[42] = monthValue;
        $[43] = setMonthValue;
        $[44] = t30;
    } else t30 = $[44];
    let t31;
    if ($[45] !== setYearValue || $[46] !== yearValue) {
        t31 = [
            yearValue,
            setYearValue
        ];
        $[45] = setYearValue;
        $[46] = yearValue;
        $[47] = t31;
    } else t31 = $[47];
    let t32;
    if ($[48] !== selectedValue || $[49] !== setSelectedValue) {
        t32 = [
            selectedValue,
            setSelectedValue
        ];
        $[48] = selectedValue;
        $[49] = setSelectedValue;
        $[50] = t32;
    } else t32 = $[50];
    let t33;
    if ($[51] !== setPreviouslySelectedValue) {
        t33 = [
            ,
            setPreviouslySelectedValue
        ];
        $[51] = setPreviouslySelectedValue;
        $[52] = t33;
    } else t33 = $[52];
    let t34;
    if ($[53] !== navigate || $[54] !== onSelectWithAnalytics || $[55] !== t29 || $[56] !== t30 || $[57] !== t31 || $[58] !== t32 || $[59] !== t33) {
        t34 = {
            day: t29,
            month: t30,
            year: t31,
            selected: t32,
            previous: t33,
            onSelect: onSelectWithAnalytics,
            navigate: navigate
        };
        $[53] = navigate;
        $[54] = onSelectWithAnalytics;
        $[55] = t29;
        $[56] = t30;
        $[57] = t31;
        $[58] = t32;
        $[59] = t33;
        $[60] = t34;
    } else t34 = $[60];
    const { handleClickDay: handleClickDay, handleContainerKeyDown: handleContainerKeyDown } = (0, $3f826.default)(t34);
    let t35;
    if ($[61] !== onBlur || $[62] !== onFocus) {
        t35 = {
            onFocus: onFocus,
            onBlur: onBlur
        };
        $[61] = onBlur;
        $[62] = onFocus;
        $[63] = t35;
    } else t35 = $[63];
    const { handleContainerBlur: handleContainerBlur, handleContainerFocus: handleContainerFocus } = (0, $669cn.default)(t35);
    let t36;
    if ($[64] !== locale || $[65] !== weekStartDay) {
        t36 = {
            locale: locale,
            weekStartDay: weekStartDay
        };
        $[64] = locale;
        $[65] = weekStartDay;
        $[66] = t36;
    } else t36 = $[66];
    const { monthsLong: monthsLong, daysShort: daysShort, daysLong: daysLong, weekStartDay: resolvedWeekStartDay } = (0, $dEHey.default)(t36);
    let t37;
    if ($[67] !== dayValue || $[68] !== daysLong || $[69] !== disabled || $[70] !== disabledDateFilter || $[71] !== maxDate || $[72] !== minDate || $[73] !== monthValue || $[74] !== previouslySelectedValue || $[75] !== resolvedWeekStartDay || $[76] !== selectedValue || $[77] !== todayValue || $[78] !== yearValue) {
        t37 = {
            day: dayValue,
            month: monthValue,
            year: yearValue,
            today: todayValue,
            selected: selectedValue,
            previouslySelected: previouslySelectedValue,
            disabled: disabled,
            disabledDateFilter: disabledDateFilter,
            minDate: minDate,
            maxDate: maxDate,
            daysLong: daysLong,
            weekStartDay: resolvedWeekStartDay
        };
        $[67] = dayValue;
        $[68] = daysLong;
        $[69] = disabled;
        $[70] = disabledDateFilter;
        $[71] = maxDate;
        $[72] = minDate;
        $[73] = monthValue;
        $[74] = previouslySelectedValue;
        $[75] = resolvedWeekStartDay;
        $[76] = selectedValue;
        $[77] = todayValue;
        $[78] = yearValue;
        $[79] = t37;
    } else t37 = $[79];
    const weeks = (0, $lq3dZ.default)(t37);
    let t38;
    if ($[80] !== monthValue || $[81] !== monthsLong || $[82] !== yearValue) {
        t38 = ()=>{
            const nextMonth = monthValue % 12;
            const showNextYear = monthValue === 12;
            return `${monthsLong[nextMonth]} ${showNextYear ? yearValue + 1 : yearValue}`;
        };
        $[80] = monthValue;
        $[81] = monthsLong;
        $[82] = yearValue;
        $[83] = t38;
    } else t38 = $[83];
    const getNextMonthHeading = t38;
    let t39;
    if ($[84] !== monthValue || $[85] !== monthsLong || $[86] !== yearValue) {
        t39 = ()=>{
            const thisMonth = (monthValue - 1) % 12;
            const nextYear = yearValue + 1;
            return `${monthsLong[thisMonth]} ${nextYear}`;
        };
        $[84] = monthValue;
        $[85] = monthsLong;
        $[86] = yearValue;
        $[87] = t39;
    } else t39 = $[87];
    const getNextYearHeading = t39;
    let t40;
    if ($[88] !== monthValue || $[89] !== monthsLong || $[90] !== yearValue) {
        t40 = ()=>{
            const previousMonth = (monthValue + 12 - 2) % 12;
            const showPreviousYear = monthValue === 1;
            return `${monthsLong[previousMonth]} ${showPreviousYear ? yearValue - 1 : yearValue}`;
        };
        $[88] = monthValue;
        $[89] = monthsLong;
        $[90] = yearValue;
        $[91] = t40;
    } else t40 = $[91];
    const getPreviousMonthHeading = t40;
    let t41;
    if ($[92] !== monthValue || $[93] !== monthsLong || $[94] !== yearValue) {
        t41 = ()=>{
            const thisMonth_0 = (monthValue - 1) % 12;
            const previousYear = yearValue - 1;
            return `${monthsLong[thisMonth_0]} ${previousYear}`;
        };
        $[92] = monthValue;
        $[93] = monthsLong;
        $[94] = yearValue;
        $[95] = t41;
    } else t41 = $[95];
    const getPreviousYearHeading = t41;
    const headerId = (0, $6JrSr.useId)();
    const t42 = testId && `${testId}--container`;
    const t43 = testId && `${testId}--calendar`;
    const t44 = monthsLong[monthValue - 1];
    const t45 = getNextMonthHeading();
    const t46 = getNextYearHeading();
    const t47 = getPreviousMonthHeading();
    const t48 = getPreviousYearHeading();
    let t49;
    if ($[96] !== handleClickNextMonth || $[97] !== handleClickNextYear || $[98] !== handleClickPrevMonth || $[99] !== handleClickPrevYear || $[100] !== headerId || $[101] !== nextMonthLabel || $[102] !== previousMonthLabel || $[103] !== t44 || $[104] !== t45 || $[105] !== t46 || $[106] !== t47 || $[107] !== t48 || $[108] !== tabIndex || $[109] !== testId || $[110] !== yearValue) {
        t49 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $CIxco.default), {
            monthLongTitle: t44,
            year: yearValue,
            nextMonthLabel: nextMonthLabel,
            previousMonthLabel: previousMonthLabel,
            nextMonthHeading: t45,
            nextYearHeading: t46,
            previousMonthHeading: t47,
            previousYearHeading: t48,
            handleClickNextMonth: handleClickNextMonth,
            handleClickNextYear: handleClickNextYear,
            handleClickPrevMonth: handleClickPrevMonth,
            handleClickPrevYear: handleClickPrevYear,
            headerId: headerId,
            tabIndex: tabIndex,
            testId: testId
        });
        $[96] = handleClickNextMonth;
        $[97] = handleClickNextYear;
        $[98] = handleClickPrevMonth;
        $[99] = handleClickPrevYear;
        $[100] = headerId;
        $[101] = nextMonthLabel;
        $[102] = previousMonthLabel;
        $[103] = t44;
        $[104] = t45;
        $[105] = t46;
        $[106] = t47;
        $[107] = t48;
        $[108] = tabIndex;
        $[109] = testId;
        $[110] = yearValue;
        $[111] = t49;
    } else t49 = $[111];
    const t50 = testId && `${testId}--calendar-dates`;
    let t51;
    if ($[112] !== daysShort || $[113] !== testId) {
        t51 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $RzcOF.default), {
            daysShort: daysShort,
            testId: testId
        });
        $[112] = daysShort;
        $[113] = testId;
        $[114] = t51;
    } else t51 = $[114];
    const t52 = shouldSetFocus || shouldSetFocusOnCurrentDay;
    let t53;
    if ($[115] !== handleClickDay || $[116] !== monthsLong || $[117] !== t52 || $[118] !== tabIndex || $[119] !== testId || $[120] !== weeks) {
        t53 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4kl0X.default), {
            weeks: weeks,
            handleClickDay: handleClickDay,
            monthsLong: monthsLong,
            shouldSetFocus: t52,
            tabIndex: tabIndex,
            testId: testId
        });
        $[115] = handleClickDay;
        $[116] = monthsLong;
        $[117] = t52;
        $[118] = tabIndex;
        $[119] = testId;
        $[120] = weeks;
        $[121] = t53;
    } else t53 = $[121];
    let t54;
    if ($[122] !== handleContainerKeyDown || $[123] !== headerId || $[124] !== t50 || $[125] !== t51 || $[126] !== t53) {
        t54 = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $iMnC5.Box), {
            role: "grid",
            onKeyDown: handleContainerKeyDown,
            "aria-labelledby": headerId,
            testId: t50,
            children: [
                t51,
                t53
            ]
        });
        $[122] = handleContainerKeyDown;
        $[123] = headerId;
        $[124] = t50;
        $[125] = t51;
        $[126] = t53;
        $[127] = t54;
    } else t54 = $[127];
    let t55;
    if ($[128] !== t49 || $[129] !== t54) {
        t55 = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $dinVW.Stack), {
            space: "space.150",
            children: [
                t49,
                t54
            ]
        });
        $[128] = t49;
        $[129] = t54;
        $[130] = t55;
    } else t55 = $[130];
    let t56;
    if ($[131] !== t43 || $[132] !== t55) {
        t56 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            xcss: $031e002627f496f2$var$styles.box,
            padding: "space.200",
            "aria-label": "calendar",
            testId: t43,
            children: t55
        });
        $[131] = t43;
        $[132] = t55;
        $[133] = t56;
    } else t56 = $[133];
    let t57;
    if ($[134] !== className || $[135] !== handleContainerBlur || $[136] !== handleContainerFocus || $[137] !== ref || $[138] !== style || $[139] !== t42 || $[140] !== t56) {
        t57 = /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            className: className,
            style: style,
            onBlur: handleContainerBlur,
            onFocus: handleContainerFocus,
            "data-testid": t42,
            ref: ref,
            children: t56
        });
        $[134] = className;
        $[135] = handleContainerBlur;
        $[136] = handleContainerFocus;
        $[137] = ref;
        $[138] = style;
        $[139] = t42;
        $[140] = t56;
        $[141] = t57;
    } else t57 = $[141];
    return t57;
} : function Calendar({ day: day, defaultDay: defaultDay = 0, defaultMonth: defaultMonth = 0, defaultPreviouslySelected: defaultPreviouslySelected = [], defaultSelected: defaultSelected = [], defaultYear: defaultYear = 0, disabled: disabled, disabledDateFilter: disabledDateFilter, minDate: minDate, maxDate: maxDate, month: month, nextMonthLabel: nextMonthLabel, onBlur: onBlur = (0, $dpsRj.default), onChange: onChange = (0, $dpsRj.default), onFocus: onFocus = (0, $dpsRj.default), onSelect: onSelect = (0, $dpsRj.default), previouslySelected: previouslySelected, previousMonthLabel: previousMonthLabel, selected: selected, shouldSetFocusOnCurrentDay: shouldSetFocusOnCurrentDay = false, today: today, locale: locale = 'en-US', year: year, analyticsContext: analyticsContext, weekStartDay: weekStartDay, testId: testId, className: className, style: style, tabIndex: tabIndex = 0 }, ref) {
    const { day: [dayValue, setDayValue], month: [monthValue, setMonthValue], year: [yearValue, setYearValue], today: [todayValue], selected: [selectedValue, setSelectedValue], previous: [previouslySelectedValue, setPreviouslySelectedValue] } = (0, $2lTKb.default)({
        day: day,
        defaultDay: defaultDay,
        month: month,
        defaultMonth: defaultMonth,
        year: year,
        defaultYear: defaultYear,
        today: today,
        selected: selected,
        defaultSelected: defaultSelected,
        previouslySelected: previouslySelected,
        defaultPreviouslySelected: defaultPreviouslySelected
    });
    const [shouldSetFocus, setShouldSetFocus] = (0, $cozmU.useState)(false);
    const onChangeWithAnalytics = (0, $7r5Hr.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        ...$031e002627f496f2$var$analyticsAttributes
    });
    const { navigate: navigate, handleClickNextMonth: handleClickNextMonth, handleClickNextYear: handleClickNextYear, handleClickPrevMonth: handleClickPrevMonth, handleClickPrevYear: handleClickPrevYear } = (0, $2NGTx.default)({
        day: [
            dayValue,
            setDayValue
        ],
        month: [
            monthValue,
            setMonthValue
        ],
        year: [
            yearValue,
            setYearValue
        ],
        shouldSetFocus: [
            shouldSetFocus,
            setShouldSetFocus
        ],
        onChange: onChangeWithAnalytics
    });
    const onSelectWithAnalytics = (0, $7r5Hr.usePlatformLeafEventHandler)({
        fn: onSelect,
        action: 'selected',
        analyticsData: analyticsContext,
        ...$031e002627f496f2$var$analyticsAttributes
    });
    const { handleClickDay: handleClickDay, handleContainerKeyDown: handleContainerKeyDown } = (0, $3f826.default)({
        day: [
            dayValue,
            setDayValue
        ],
        month: [
            monthValue,
            setMonthValue
        ],
        year: [
            yearValue,
            setYearValue
        ],
        selected: [
            selectedValue,
            setSelectedValue
        ],
        previous: [
            ,
            setPreviouslySelectedValue
        ],
        onSelect: onSelectWithAnalytics,
        navigate: navigate
    });
    const { handleContainerBlur: handleContainerBlur, handleContainerFocus: handleContainerFocus } = (0, $669cn.default)({
        onFocus: onFocus,
        onBlur: onBlur
    });
    const { monthsLong: monthsLong, daysShort: daysShort, daysLong: daysLong, weekStartDay: resolvedWeekStartDay } = (0, $dEHey.default)({
        locale: locale,
        weekStartDay: weekStartDay
    });
    const weeks = (0, $lq3dZ.default)({
        day: dayValue,
        month: monthValue,
        year: yearValue,
        today: todayValue,
        selected: selectedValue,
        previouslySelected: previouslySelectedValue,
        disabled: disabled,
        disabledDateFilter: disabledDateFilter,
        minDate: minDate,
        maxDate: maxDate,
        daysLong: daysLong,
        weekStartDay: resolvedWeekStartDay
    });
    const getNextMonthHeading = ()=>{
        // Next month is (currentMonth - 1) + 1, or just currentMonth in this
        // instance.
        const nextMonth = monthValue % 12;
        const showNextYear = monthValue === 12;
        return `${monthsLong[nextMonth]} ${showNextYear ? yearValue + 1 : yearValue}`;
    };
    const getNextYearHeading = ()=>{
        // Months are held in Date object as zero-indexed
        const thisMonth = (monthValue - 1) % 12;
        const nextYear = yearValue + 1;
        return `${monthsLong[thisMonth]} ${nextYear}`;
    };
    const getPreviousMonthHeading = ()=>{
        // Previous month is (monthValue - 1) - 1. Need to add 12 so the modulo
        // works as expected and stays positive.
        const previousMonth = (monthValue + 12 - 2) % 12;
        const showPreviousYear = monthValue === 1;
        return `${monthsLong[previousMonth]} ${showPreviousYear ? yearValue - 1 : yearValue}`;
    };
    const getPreviousYearHeading = ()=>{
        // Months are held in Date object as zero-indexed
        const thisMonth_0 = (monthValue - 1) % 12;
        const previousYear = yearValue - 1;
        return `${monthsLong[thisMonth_0]} ${previousYear}`;
    };
    const headerId = (0, $6JrSr.useId)();
    return /*#__PURE__*/ (0, $8aG6j.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: className,
        style: style,
        onBlur: handleContainerBlur,
        onFocus: handleContainerFocus,
        "data-testid": testId && `${testId}--container`,
        ref: ref,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            xcss: $031e002627f496f2$var$styles.box,
            padding: "space.200",
            "aria-label": "calendar",
            testId: testId && `${testId}--calendar`,
            children: /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $dinVW.Stack), {
                space: "space.150",
                children: [
                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $CIxco.default // The month number needs to be translated to index in the month
                    ), {
                        // name array e.g. 1 (January) -> 0
                        monthLongTitle: monthsLong[monthValue - 1],
                        year: yearValue,
                        nextMonthLabel: nextMonthLabel,
                        previousMonthLabel: previousMonthLabel,
                        nextMonthHeading: getNextMonthHeading(),
                        nextYearHeading: getNextYearHeading(),
                        previousMonthHeading: getPreviousMonthHeading(),
                        previousYearHeading: getPreviousYearHeading(),
                        handleClickNextMonth: handleClickNextMonth,
                        handleClickNextYear: handleClickNextYear,
                        handleClickPrevMonth: handleClickPrevMonth,
                        handleClickPrevYear: handleClickPrevYear,
                        headerId: headerId,
                        tabIndex: tabIndex,
                        testId: testId
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $iMnC5.Box), {
                        role: "grid",
                        onKeyDown: handleContainerKeyDown,
                        "aria-labelledby": headerId,
                        testId: testId && `${testId}--calendar-dates`,
                        children: [
                            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $RzcOF.default), {
                                daysShort: daysShort,
                                testId: testId
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4kl0X.default), {
                                weeks: weeks,
                                handleClickDay: handleClickDay,
                                monthsLong: monthsLong,
                                shouldSetFocus: shouldSetFocus || shouldSetFocusOnCurrentDay,
                                tabIndex: tabIndex,
                                testId: testId
                            })
                        ]
                    })
                ]
            })
        })
    });
});
/**
 * __Calendar__
 *
 * A calendar is used for date selection.
 *
 * - [Examples](https://atlassian.design/components/calendar/examples)
 * - [Code](https://atlassian.design/components/calendar/code)
 * - [Usage](https://atlassian.design/components/calendar/usage)
 */ const $031e002627f496f2$var$Calendar = /*#__PURE__*/ (0, $cozmU.memo)(/*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? function Calendar(props, ref) {
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] !== props || $[1] !== ref) {
        t0 = /*#__PURE__*/ (0, $8aG6j.jsx)($031e002627f496f2$var$InnerCalendar, {
            ...props,
            ref: ref
        });
        $[0] = props;
        $[1] = ref;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : function Calendar(props, ref) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)($031e002627f496f2$var$InnerCalendar, {
        ...props,
        ref: ref
    });
}));
$031e002627f496f2$var$Calendar.displayName = 'Calendar';
var $031e002627f496f2$export$2e2bcd8739ae039 = $031e002627f496f2$var$Calendar;
module.exports["default"] = $031e002627f496f2$export$2e2bcd8739ae039;

});

parcelRegister("CIxco", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $1sCHt = parcelRequire("1sCHt");


var $6JrSr = parcelRequire("6JrSr");


var $I7hWB = parcelRequire("I7hWB");


var $fvQZz = parcelRequire("fvQZz");


var $jA2WU = parcelRequire("jA2WU");


var $iW7aI = parcelRequire("iW7aI");


var $aDSIl = parcelRequire("aDSIl");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");

// in the return below and always apply these transitions.
const $3cbb052d9d086c02$var$arrowMotionStyles = null;
const $3cbb052d9d086c02$var$Header = /*#__PURE__*/ (0, $cozmU.memo)((0, $gtMdU.isReactCompilerActivePlatform)() ? function Header(t0) {
    const $ = (0, $bDgLe.c)(51);
    const { monthLongTitle: monthLongTitle, year: year, previousMonthLabel: t1, previousYearLabel: t2, previousMonthHeading: previousMonthHeading, previousYearHeading: previousYearHeading, nextMonthLabel: t3, nextYearLabel: t4, nextMonthHeading: nextMonthHeading, nextYearHeading: nextYearHeading, handleClickPrevMonth: handleClickPrevMonth, handleClickPrevYear: handleClickPrevYear, handleClickNextMonth: handleClickNextMonth, handleClickNextYear: handleClickNextYear, headerId: headerId, tabIndex: tabIndex, testId: testId } = t0;
    const previousMonthLabel = t1 === undefined ? "Previous month" : t1;
    const previousYearLabel = t2 === undefined ? "Previous year" : t2;
    const nextMonthLabel = t3 === undefined ? "Next month" : t3;
    const nextYearLabel = t4 === undefined ? "Next year" : t4;
    const announceId = (0, $6JrSr.useId)();
    const [hasInteractedWithMonthOrYear, setHasInteractedWithMonthOrYear] = (0, $cozmU.useState)(false);
    let t5;
    if ($[0] !== handleClickPrevMonth || $[1] !== hasInteractedWithMonthOrYear) {
        t5 = (e)=>{
            if (!hasInteractedWithMonthOrYear) setHasInteractedWithMonthOrYear(true);
            handleClickPrevMonth(e);
        };
        $[0] = handleClickPrevMonth;
        $[1] = hasInteractedWithMonthOrYear;
        $[2] = t5;
    } else t5 = $[2];
    const handlePrevMonthInteraction = t5;
    let t6;
    if ($[3] !== handleClickPrevYear || $[4] !== hasInteractedWithMonthOrYear) {
        t6 = (e_0)=>{
            if (!hasInteractedWithMonthOrYear) setHasInteractedWithMonthOrYear(true);
            handleClickPrevYear(e_0);
        };
        $[3] = handleClickPrevYear;
        $[4] = hasInteractedWithMonthOrYear;
        $[5] = t6;
    } else t6 = $[5];
    const handlePrevYearInteraction = t6;
    let t7;
    if ($[6] !== handleClickNextMonth || $[7] !== hasInteractedWithMonthOrYear) {
        t7 = (e_1)=>{
            if (!hasInteractedWithMonthOrYear) setHasInteractedWithMonthOrYear(true);
            handleClickNextMonth(e_1);
        };
        $[6] = handleClickNextMonth;
        $[7] = hasInteractedWithMonthOrYear;
        $[8] = t7;
    } else t7 = $[8];
    const handleNextMonthInteraction = t7;
    let t8;
    if ($[9] !== handleClickNextYear || $[10] !== hasInteractedWithMonthOrYear) {
        t8 = (e_2)=>{
            if (!hasInteractedWithMonthOrYear) setHasInteractedWithMonthOrYear(true);
            handleClickNextYear(e_2);
        };
        $[9] = handleClickNextYear;
        $[10] = hasInteractedWithMonthOrYear;
        $[11] = t8;
    } else t8 = $[11];
    const handleNextYearInteraction = t8;
    const t9 = testId && `${testId}--previous-year`;
    const t10 = `${previousYearLabel}, ${previousYearHeading}`;
    let t11;
    if ($[12] !== handlePrevYearInteraction || $[13] !== t10 || $[14] !== t9 || $[15] !== tabIndex) {
        t11 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1sCHt.default), {
            appearance: "subtle",
            spacing: "compact",
            tabIndex: tabIndex,
            onClick: handlePrevYearInteraction,
            testId: t9,
            icon: $3cbb052d9d086c02$var$_temp,
            label: t10
        });
        $[12] = handlePrevYearInteraction;
        $[13] = t10;
        $[14] = t9;
        $[15] = tabIndex;
        $[16] = t11;
    } else t11 = $[16];
    const t12 = testId && `${testId}--previous-month`;
    const t13 = `${previousMonthLabel}, ${previousMonthHeading}`;
    let t14;
    if ($[17] !== handlePrevMonthInteraction || $[18] !== t12 || $[19] !== t13 || $[20] !== tabIndex) {
        t14 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1sCHt.default), {
            appearance: "subtle",
            spacing: "compact",
            tabIndex: tabIndex,
            onClick: handlePrevMonthInteraction,
            testId: t12,
            icon: $3cbb052d9d086c02$var$_temp2,
            label: t13
        });
        $[17] = handlePrevMonthInteraction;
        $[18] = t12;
        $[19] = t13;
        $[20] = tabIndex;
        $[21] = t14;
    } else t14 = $[21];
    let t15;
    if ($[22] !== t11 || $[23] !== t14) {
        t15 = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
            space: "space.100",
            alignBlock: "start",
            children: [
                t11,
                t14
            ]
        });
        $[22] = t11;
        $[23] = t14;
        $[24] = t15;
    } else t15 = $[24];
    const t16 = hasInteractedWithMonthOrYear ? "polite" : undefined;
    const t17 = testId && `${testId}--current-month-year--container`;
    const t18 = testId && `${testId}--current-month-year`;
    const t19 = `${monthLongTitle} ${year}`;
    let t20;
    if ($[25] !== headerId || $[26] !== t18 || $[27] !== t19) {
        t20 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $I7hWB.default), {
            size: "xsmall",
            as: "h2",
            id: headerId,
            testId: t18,
            children: t19
        });
        $[25] = headerId;
        $[26] = t18;
        $[27] = t19;
        $[28] = t20;
    } else t20 = $[28];
    let t21;
    if ($[29] !== announceId || $[30] !== t16 || $[31] !== t17 || $[32] !== t20) {
        t21 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            "aria-live": t16,
            id: announceId,
            testId: t17,
            children: t20
        });
        $[29] = announceId;
        $[30] = t16;
        $[31] = t17;
        $[32] = t20;
        $[33] = t21;
    } else t21 = $[33];
    const t22 = testId && `${testId}--next-month`;
    const t23 = `${nextMonthLabel}, ${nextMonthHeading}`;
    let t24;
    if ($[34] !== handleNextMonthInteraction || $[35] !== t22 || $[36] !== t23 || $[37] !== tabIndex) {
        t24 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1sCHt.default), {
            appearance: "subtle",
            spacing: "compact",
            tabIndex: tabIndex,
            onClick: handleNextMonthInteraction,
            testId: t22,
            icon: $3cbb052d9d086c02$var$_temp3,
            label: t23
        });
        $[34] = handleNextMonthInteraction;
        $[35] = t22;
        $[36] = t23;
        $[37] = tabIndex;
        $[38] = t24;
    } else t24 = $[38];
    const t25 = testId && `${testId}--next-year`;
    const t26 = `${nextYearLabel}, ${nextYearHeading}`;
    let t27;
    if ($[39] !== handleNextYearInteraction || $[40] !== t25 || $[41] !== t26 || $[42] !== tabIndex) {
        t27 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1sCHt.default), {
            appearance: "subtle",
            spacing: "compact",
            tabIndex: tabIndex,
            onClick: handleNextYearInteraction,
            testId: t25,
            icon: $3cbb052d9d086c02$var$_temp4,
            label: t26
        });
        $[39] = handleNextYearInteraction;
        $[40] = t25;
        $[41] = t26;
        $[42] = tabIndex;
        $[43] = t27;
    } else t27 = $[43];
    let t28;
    if ($[44] !== t24 || $[45] !== t27) {
        t28 = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
            space: "space.100",
            alignBlock: "end",
            children: [
                t24,
                t27
            ]
        });
        $[44] = t24;
        $[45] = t27;
        $[46] = t28;
    } else t28 = $[46];
    let t29;
    if ($[47] !== t15 || $[48] !== t21 || $[49] !== t28) {
        const header = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            paddingInline: "space.100",
            children: /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
                space: "space.0",
                alignBlock: "center",
                spread: "space-between",
                children: [
                    t15,
                    t21,
                    t28
                ]
            })
        });
        t29 = (0, $iDrrr.fg)("platform-dst-motion-uplift-list-item") ? /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            className: (0, $hekY6.default)([
                "_4dF6NMswLo _499rSRswLo _4AHf5IDGiy _08mev2YbGa"
            ]),
            children: header
        }) : header;
        $[47] = t15;
        $[48] = t21;
        $[49] = t28;
        $[50] = t29;
    } else t29 = $[50];
    return t29;
} : function Header({ monthLongTitle: monthLongTitle, year: year, previousMonthLabel: previousMonthLabel = 'Previous month', previousYearLabel: previousYearLabel = 'Previous year', previousMonthHeading: previousMonthHeading, previousYearHeading: previousYearHeading, nextMonthLabel: nextMonthLabel = 'Next month', nextYearLabel: nextYearLabel = 'Next year', nextMonthHeading: nextMonthHeading, nextYearHeading: nextYearHeading, handleClickPrevMonth: handleClickPrevMonth, handleClickPrevYear: handleClickPrevYear, handleClickNextMonth: handleClickNextMonth, handleClickNextYear: handleClickNextYear, headerId: headerId, tabIndex: tabIndex, testId: testId }) {
    const announceId = (0, $6JrSr.useId)(); // All of this is because `aria-atomic` is not fully supported for different
    // assistive technologies. We want the value of the current month and year to
    // be announced, but *only* if that value has been interacted with since
    // being mounted. This allows us to conditionally apply the `aria-live`
    // attribute.  Without this, the `aria-live` property is set on mount and
    // overrides the default input's readout in downstream consumers (e.g.
    // datetime picker).
    const [hasInteractedWithMonthOrYear, setHasInteractedWithMonthOrYear] = (0, $cozmU.useState)(false);
    const handlePrevMonthInteraction = (e)=>{
        if (!hasInteractedWithMonthOrYear) setHasInteractedWithMonthOrYear(true);
        handleClickPrevMonth(e);
    };
    const handlePrevYearInteraction = (e_0)=>{
        if (!hasInteractedWithMonthOrYear) setHasInteractedWithMonthOrYear(true);
        handleClickPrevYear(e_0);
    };
    const handleNextMonthInteraction = (e_1)=>{
        if (!hasInteractedWithMonthOrYear) setHasInteractedWithMonthOrYear(true);
        handleClickNextMonth(e_1);
    };
    const handleNextYearInteraction = (e_2)=>{
        if (!hasInteractedWithMonthOrYear) setHasInteractedWithMonthOrYear(true);
        handleClickNextYear(e_2);
    };
    const header = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        paddingInline: "space.100",
        children: /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
            space: "space.0",
            alignBlock: "center",
            spread: "space-between",
            children: [
                /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
                    space: "space.100",
                    alignBlock: "start",
                    children: [
                        /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1sCHt.default), {
                            appearance: "subtle",
                            spacing: "compact",
                            tabIndex: tabIndex,
                            onClick: handlePrevYearInteraction,
                            testId: testId && `${testId}--previous-year`,
                            icon: (iconProps)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fvQZz))), {
                                    ...iconProps,
                                    size: "small"
                                }),
                            label: `${previousYearLabel}, ${previousYearHeading}`
                        }),
                        /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1sCHt.default), {
                            appearance: "subtle",
                            spacing: "compact",
                            tabIndex: tabIndex,
                            onClick: handlePrevMonthInteraction,
                            testId: testId && `${testId}--previous-month`,
                            icon: (iconProps_0)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iW7aI))), {
                                    ...iconProps_0,
                                    size: "small"
                                }),
                            label: `${previousMonthLabel}, ${previousMonthHeading}`
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                    "aria-live": hasInteractedWithMonthOrYear ? 'polite' : undefined,
                    id: announceId,
                    testId: testId && `${testId}--current-month-year--container`,
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $I7hWB.default), {
                        size: "xsmall",
                        as: "h2",
                        id: headerId,
                        testId: testId && `${testId}--current-month-year`,
                        children: `${monthLongTitle} ${year}`
                    })
                }),
                /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
                    space: "space.100",
                    alignBlock: "end",
                    children: [
                        /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1sCHt.default), {
                            appearance: "subtle",
                            spacing: "compact",
                            tabIndex: tabIndex,
                            onClick: handleNextMonthInteraction,
                            testId: testId && `${testId}--next-month`,
                            icon: (iconProps_1)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))), {
                                    ...iconProps_1,
                                    size: "small"
                                }),
                            label: `${nextMonthLabel}, ${nextMonthHeading}`
                        }),
                        /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1sCHt.default), {
                            appearance: "subtle",
                            spacing: "compact",
                            tabIndex: tabIndex,
                            onClick: handleNextYearInteraction,
                            testId: testId && `${testId}--next-year`,
                            icon: (iconProps_2)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jA2WU))), {
                                    ...iconProps_2,
                                    size: "small"
                                }),
                            label: `${nextYearLabel}, ${nextYearHeading}`
                        })
                    ]
                })
            ]
        })
    });
    return (0, $iDrrr.fg)('platform-dst-motion-uplift-list-item') ? /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        className: (0, $hekY6.default)([
            "_4dF6NMswLo _499rSRswLo _4AHf5IDGiy _08mev2YbGa"
        ]),
        children: header
    }) : header;
});
$3cbb052d9d086c02$var$Header.displayName = 'Header'; // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $3cbb052d9d086c02$export$2e2bcd8739ae039 = $3cbb052d9d086c02$var$Header;
function $3cbb052d9d086c02$var$_temp(iconProps) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fvQZz))), {
        ...iconProps,
        size: "small"
    });
}
function $3cbb052d9d086c02$var$_temp2(iconProps_0) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iW7aI))), {
        ...iconProps_0,
        size: "small"
    });
}
function $3cbb052d9d086c02$var$_temp3(iconProps_1) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))), {
        ...iconProps_1,
        size: "small"
    });
}
function $3cbb052d9d086c02$var$_temp4(iconProps_2) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jA2WU))), {
        ...iconProps_2,
        size: "small"
    });
}
module.exports["default"] = $3cbb052d9d086c02$export$2e2bcd8739ae039;

});

parcelRegister("fvQZz", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::30c4d8563d4405635aa2922e0e9918c6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b4b2db60ae791156$var$_react = $b4b2db60ae791156$var$_interopRequireDefault((parcelRequire("cozmU")));

var $b4b2db60ae791156$var$_iconNew = $b4b2db60ae791156$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $b4b2db60ae791156$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronDoubleLeft".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/chevron-double-left
 * Usage guidance:
 * Known uses: Navigate to previous year in calendar/date picker
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b4b2db60ae791156$var$ChevronDoubleLeftIcon = (props)=>/*#__PURE__*/ $b4b2db60ae791156$var$_react.default.createElement($b4b2db60ae791156$var$_iconNew.default, Object.assign({
        name: "ChevronDoubleLeftIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m7.72 1.47-6 6a.75.75 0 0 0-.052 1.004l.052.056 6 6 1.06-1.06L3.31 8l5.47-5.47z"/><path fill="currentcolor" d="m12.47 1.47-6 6a.75.75 0 0 0-.052 1.004l.052.056 6 6 1.06-1.06L8.06 8l5.47-5.47z"/>`
    }, props));
$b4b2db60ae791156$var$ChevronDoubleLeftIcon.displayName = 'ChevronDoubleLeftIcon';
var $b4b2db60ae791156$var$_default = module.exports.default = $b4b2db60ae791156$var$ChevronDoubleLeftIcon;

});

parcelRegister("jA2WU", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::29c7322dd95328d239ae1ca6bd298f91>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e413aabb142774f3$var$_react = $e413aabb142774f3$var$_interopRequireDefault((parcelRequire("cozmU")));

var $e413aabb142774f3$var$_iconNew = $e413aabb142774f3$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $e413aabb142774f3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronDoubleRight".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/chevron-double-right
 * Usage guidance:
 * Known uses: Navigate to next year in calendar/date picker
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e413aabb142774f3$var$ChevronDoubleRightIcon = (props)=>/*#__PURE__*/ $e413aabb142774f3$var$_react.default.createElement($e413aabb142774f3$var$_iconNew.default, Object.assign({
        name: "ChevronDoubleRightIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m8.28 1.47 6 6a.75.75 0 0 1 .052 1.004l-.052.056-6 6-1.06-1.06L12.69 8 7.22 2.53z"/><path fill="currentcolor" d="m3.53 1.47 6 6a.75.75 0 0 1 .052 1.004l-.052.056-6 6-1.06-1.06L7.94 8 2.47 2.53z"/>`
    }, props));
$e413aabb142774f3$var$ChevronDoubleRightIcon.displayName = 'ChevronDoubleRightIcon';
var $e413aabb142774f3$var$_default = module.exports.default = $e413aabb142774f3$var$ChevronDoubleRightIcon;

});

parcelRegister("4kl0X", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $3izAL = parcelRequire("3izAL");


var $eg4l6 = parcelRequire("eg4l6");


var $4Xsrc = parcelRequire("4Xsrc");

const $d0e1499518f2d7f3$var$WeekDays = /*#__PURE__*/ (0, $cozmU.memo)((0, $gtMdU.isReactCompilerActivePlatform)() ? function WeekDays(t0) {
    const $ = (0, $bDgLe.c)(16);
    const { weeks: weeks, handleClickDay: handleClickDay, monthsLong: monthsLong, shouldSetFocus: shouldSetFocus, tabIndex: tabIndex, testId: testId } = t0;
    const t1 = testId && `${testId}--month`;
    let t2;
    if ($[0] !== handleClickDay || $[1] !== monthsLong || $[2] !== shouldSetFocus || $[3] !== tabIndex || $[4] !== testId || $[5] !== weeks) {
        let t3;
        if ($[7] !== handleClickDay || $[8] !== monthsLong || $[9] !== shouldSetFocus || $[10] !== tabIndex || $[11] !== testId) {
            t3 = (week, i)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $4Xsrc.default), {
                    testId: testId && `${testId}--week`,
                    children: week.values.map((weekDay)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $eg4l6.default), {
                            isDisabled: weekDay.isDisabled,
                            isFocused: weekDay.isFocused,
                            isToday: weekDay.isToday,
                            dayLong: weekDay.weekDayName,
                            month: weekDay.month,
                            monthLong: monthsLong[weekDay.month - 1],
                            onClick: handleClickDay,
                            isPreviouslySelected: weekDay.isPreviouslySelected,
                            isSelected: weekDay.isSelected,
                            isSibling: weekDay.isSiblingMonth,
                            year: weekDay.year,
                            shouldSetFocus: shouldSetFocus,
                            tabIndex: tabIndex,
                            testId: testId,
                            children: weekDay.day
                        }, `${week.id}-${weekDay.id}`))
                }, i);
            $[7] = handleClickDay;
            $[8] = monthsLong;
            $[9] = shouldSetFocus;
            $[10] = tabIndex;
            $[11] = testId;
            $[12] = t3;
        } else t3 = $[12];
        t2 = weeks.map(t3);
        $[0] = handleClickDay;
        $[1] = monthsLong;
        $[2] = shouldSetFocus;
        $[3] = tabIndex;
        $[4] = testId;
        $[5] = weeks;
        $[6] = t2;
    } else t2 = $[6];
    let t3;
    if ($[13] !== t1 || $[14] !== t2) {
        t3 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $3izAL.default), {
            role: "rowgroup",
            testId: t1,
            children: t2
        });
        $[13] = t1;
        $[14] = t2;
        $[15] = t3;
    } else t3 = $[15];
    return t3;
} : function WeekDays({ weeks: weeks, handleClickDay: handleClickDay, monthsLong: monthsLong, shouldSetFocus: shouldSetFocus, tabIndex: tabIndex, testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $3izAL.default), {
        role: "rowgroup",
        testId: testId && `${testId}--month`,
        children: weeks.map((week, i)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $4Xsrc.default), {
                testId: testId && `${testId}--week`,
                children: week.values.map((weekDay)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $eg4l6.default), {
                        isDisabled: weekDay.isDisabled,
                        isFocused: weekDay.isFocused,
                        isToday: weekDay.isToday,
                        dayLong: weekDay.weekDayName,
                        month: weekDay.month,
                        monthLong: monthsLong[weekDay.month - 1],
                        onClick: handleClickDay,
                        isPreviouslySelected: weekDay.isPreviouslySelected,
                        isSelected: weekDay.isSelected,
                        isSibling: weekDay.isSiblingMonth,
                        year: weekDay.year,
                        shouldSetFocus: shouldSetFocus,
                        tabIndex: tabIndex,
                        testId: testId,
                        children: weekDay.day
                    }, `${week.id}-${weekDay.id}`))
            }, i))
    });
});
$d0e1499518f2d7f3$var$WeekDays.displayName = 'WeekDays';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$d0e1499518f2d7f3$export$2e2bcd8739ae039 = $d0e1499518f2d7f3$var$WeekDays;
module.exports["default"] = $d0e1499518f2d7f3$export$2e2bcd8739ae039;

});

parcelRegister("eg4l6", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $dpsRj = parcelRequire("dpsRj");


var $iDrrr = parcelRequire("iDrrr");


var $3pCca = parcelRequire("3pCca");

const $c1121364af7966f7$var$dateCellSiblingStyle = null;
const $c1121364af7966f7$var$dateCellTodayStyle = null;
const $c1121364af7966f7$var$dateCellPrevSelectedStyle = null;
const $c1121364af7966f7$var$dateCellSelectedStyle = null; // platform-dst-tokens-finesse cleanup: merge into dateCellSelectedStyle after rollout
const $c1121364af7966f7$var$dateCellSelectedFinesseStyle = null;
const $c1121364af7966f7$var$dateCellDisabledStyle = null;
const $c1121364af7966f7$var$dateCellStyles = null; // platform-dst-motion-uplift-list-item cleanup: once fully rolled out, fold these
// transitions into the styles above and drop the gate in the `css` array below.
const $c1121364af7966f7$var$dateCellMotionStyles = null;
const $c1121364af7966f7$var$dateCellSelectedMotionStyles = null;
const $c1121364af7966f7$var$Date = /*#__PURE__*/ (0, $cozmU.memo)(/*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, _ref)=>{
    const $ = (0, $bDgLe.c)(41);
    const { children: day, isDisabled: t1, isFocused: t2, isToday: t3, dayLong: dayLong, month: month, monthLong: monthLong, onClick: t4, isPreviouslySelected: t5, isSelected: t6, isSibling: t7, year: year, shouldSetFocus: shouldSetFocus, tabIndex: tabIndex, testId: testId } = t0;
    const isDisabled = t1 === undefined ? false : t1;
    const isFocused = t2 === undefined ? false : t2;
    const isToday = t3 === undefined ? false : t3;
    const onClick = t4 === undefined ? (0, $dpsRj.default) : t4;
    const isPreviouslySelected = t5 === undefined ? false : t5;
    const isSelected = t6 === undefined ? false : t6;
    const isSibling = t7 === undefined ? false : t7;
    let t8;
    if ($[0] !== day || $[1] !== isDisabled || $[2] !== month || $[3] !== year) {
        t8 = {
            day: day,
            month: month,
            year: year,
            isDisabled: isDisabled
        };
        $[0] = day;
        $[1] = isDisabled;
        $[2] = month;
        $[3] = year;
        $[4] = t8;
    } else t8 = $[4];
    const dateRef = (0, $cozmU.useRef)(t8);
    let t10;
    let t9;
    if ($[5] !== day || $[6] !== isDisabled || $[7] !== month || $[8] !== year) {
        t9 = ()=>{
            dateRef.current = {
                day: day,
                month: month,
                year: year,
                isDisabled: isDisabled
            };
        };
        t10 = [
            day,
            month,
            year,
            isDisabled
        ];
        $[5] = day;
        $[6] = isDisabled;
        $[7] = month;
        $[8] = year;
        $[9] = t10;
        $[10] = t9;
    } else {
        t10 = $[9];
        t9 = $[10];
    }
    (0, $cozmU.useEffect)(t9, t10);
    const focusRef = (0, $cozmU.useRef)(null);
    let t11;
    let t12;
    if ($[11] !== isFocused || $[12] !== shouldSetFocus) {
        t11 = ()=>{
            if (isFocused && shouldSetFocus && focusRef.current) focusRef.current.focus();
        };
        t12 = [
            isFocused,
            shouldSetFocus
        ];
        $[11] = isFocused;
        $[12] = shouldSetFocus;
        $[13] = t11;
        $[14] = t12;
    } else {
        t11 = $[13];
        t12 = $[14];
    }
    (0, $cozmU.useEffect)(t11, t12);
    let t13;
    if ($[15] !== onClick) {
        t13 = ()=>{
            const { day: dayValue, month: monthValue, year: yearValue, isDisabled: isDisabledValue } = dateRef.current;
            if (!isDisabledValue) onClick({
                day: dayValue,
                month: monthValue,
                year: yearValue
            });
        };
        $[15] = onClick;
        $[16] = t13;
    } else t13 = $[16];
    const handleClick = t13;
    const t14 = isToday ? "date" : undefined;
    const t15 = isDisabled || undefined;
    const t16 = `${day}, ${dayLong} ${monthLong} ${year}`;
    const t17 = isSelected ? "true" : "false";
    const t18 = isFocused ? tabIndex : -1;
    const t19 = isDisabled || undefined;
    const t20 = isFocused || undefined;
    const t21 = isPreviouslySelected || undefined;
    const t22 = isSelected || undefined;
    const t23 = isSibling || undefined;
    const t24 = isToday || undefined;
    const t25 = testId && (isSelected ? `${testId}--selected-day` : `${testId}--day`);
    const t26 = isSibling && "_23rrnHswLo _1UtDYzKGUX _0clgaMKGUX";
    const t27 = isToday && "_1UtDYzjTy9 _1kk5Tkmb2E _4Gb5FivLZJ _47eTBt4Jdh _2WYcYGWVPG _3wEj0X98eZ _0GBAIrogpp _3ufiZDFQfX _3erkSQFQfX _13xWvlFQfX";
    const t28 = isPreviouslySelected && "_23rrnHswLo _0KLXruY9q9 _1UtDYzZpcK _0clgaMZpcK";
    const t29 = isSelected && "_23rrnHswLo _0KLXruY9q9 _1UtDYzjTy9 _1eOmH6sumd _0clgaMjTy9";
    let t30;
    if ($[17] !== isDisabled || $[18] !== isPreviouslySelected || $[19] !== isSelected || $[20] !== t26 || $[21] !== t27 || $[22] !== t28 || $[23] !== t29) {
        t30 = (0, $hekY6.default)([
            "_1mb4UnZqHV _0bjKvDKTcp _2sNsIgmnOE _23rrnHswLo _3vBAKHjOvk _3hxITi6wH8 _2V7sgO2M4S _3iDTPbvLZJ _1mT5xdRAKS _2O5Vij7dHp _0KLXrujOvk _1UtDYzy7kJ _0wOv4Q7zJH _0xmtko1Y8M _46hvQm1Y8M _03SyCP2AF2 _0LQT5E2AF2 _2fwxA5DIqT _1H5Ii9nXvL _2pF7Yy6wH8 _4ydpeVvc3e _1eOmH6o126 _0clgaMy7kJ _3sFUREDGiy _3gzVzLN4oS _0CMRbky7kJ",
            t26,
            t27,
            t28,
            t29,
            isSelected && (0, $iDrrr.fg)("platform-dst-tokens-finesse") && "_23rrnHswLo _0KLXrukLmD _1UtDYze5R3 _1eOmH6XLOx _0clgaMe5R3 _3sFUREDGiy _3gzVzLPSfI _0CMRbke5R3",
            isDisabled && "_23rrnHswLo _1UtDYzot27 _0wOv4Qsyl5 _1eOmH6jOvk _0clgaMot27",
            (0, $iDrrr.fg)("platform-dst-motion-uplift-list-item") && "_23rrnHswLo _3t4LwpYbGa _1B4rbIswLo _3sFUREDGiy",
            (isSelected || isPreviouslySelected) && (0, $iDrrr.fg)("platform-dst-motion-uplift-list-item") && "_23rrnHzzT7"
        ]);
        $[17] = isDisabled;
        $[18] = isPreviouslySelected;
        $[19] = isSelected;
        $[20] = t26;
        $[21] = t27;
        $[22] = t28;
        $[23] = t29;
        $[24] = t30;
    } else t30 = $[24];
    let t31;
    if ($[25] !== day || $[26] !== handleClick || $[27] !== t14 || $[28] !== t15 || $[29] !== t16 || $[30] !== t17 || $[31] !== t18 || $[32] !== t19 || $[33] !== t20 || $[34] !== t21 || $[35] !== t22 || $[36] !== t23 || $[37] !== t24 || $[38] !== t25 || $[39] !== t30) {
        t31 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $3pCca.Grid), {
            role: "gridcell",
            alignItems: "center",
            children: /*#__PURE__*/ (0, $8aG6j.jsx)("button", {
                "aria-current": t14,
                "aria-disabled": t15,
                "aria-label": t16,
                "aria-pressed": t17,
                tabIndex: t18,
                type: "button",
                onClick: handleClick,
                ref: focusRef,
                "data-disabled": t19,
                "data-focused": t20,
                "data-prev-selected": t21,
                "data-selected": t22,
                "data-sibling": t23,
                "data-today": t24,
                "data-testid": t25,
                className: t30,
                children: day
            })
        });
        $[25] = day;
        $[26] = handleClick;
        $[27] = t14;
        $[28] = t15;
        $[29] = t16;
        $[30] = t17;
        $[31] = t18;
        $[32] = t19;
        $[33] = t20;
        $[34] = t21;
        $[35] = t22;
        $[36] = t23;
        $[37] = t24;
        $[38] = t25;
        $[39] = t30;
        $[40] = t31;
    } else t31 = $[40];
    return t31;
} : ({ children: day, isDisabled: isDisabled = false, isFocused: isFocused = false, isToday: isToday = false, dayLong: dayLong, month: month, monthLong: monthLong, onClick: onClick = (0, $dpsRj.default), isPreviouslySelected: isPreviouslySelected = false, isSelected: isSelected = false, isSibling: isSibling = false, year: year, shouldSetFocus: shouldSetFocus, tabIndex: tabIndex, testId: testId }, _ref)=>{
    const dateRef = (0, $cozmU.useRef)({
        day: day,
        month: month,
        year: year,
        isDisabled: isDisabled
    });
    (0, $cozmU.useEffect)(()=>{
        dateRef.current = {
            day: day,
            month: month,
            year: year,
            isDisabled: isDisabled
        };
    }, [
        day,
        month,
        year,
        isDisabled
    ]);
    const focusRef = (0, $cozmU.useRef)(null);
    (0, $cozmU.useEffect)(()=>{
        if (isFocused && shouldSetFocus && focusRef.current) focusRef.current.focus();
    }, [
        isFocused,
        shouldSetFocus
    ]);
    const handleClick = (0, $cozmU.useCallback)(()=>{
        const { day: dayValue, month: monthValue, year: yearValue, isDisabled: isDisabledValue } = dateRef.current;
        if (!isDisabledValue) onClick({
            day: dayValue,
            month: monthValue,
            year: yearValue
        });
    }, [
        onClick
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $3pCca.Grid), {
        role: "gridcell",
        alignItems: "center",
        children: /*#__PURE__*/ (0, $8aG6j.jsx)("button", {
            "aria-current": isToday ? 'date' : undefined,
            "aria-disabled": isDisabled || undefined,
            "aria-label": `${day}, ${dayLong} ${monthLong} ${year}`,
            "aria-pressed": isSelected ? 'true' : 'false',
            tabIndex: isFocused ? tabIndex : -1,
            type: "button",
            onClick: handleClick,
            ref: focusRef,
            "data-disabled": isDisabled || undefined,
            "data-focused": isFocused || undefined,
            "data-prev-selected": isPreviouslySelected || undefined,
            "data-selected": isSelected || undefined,
            "data-sibling": isSibling || undefined,
            "data-today": isToday || undefined,
            "data-testid": testId && (isSelected ? `${testId}--selected-day` : `${testId}--day`),
            className: (0, $hekY6.default)([
                "_1mb4UnZqHV _0bjKvDKTcp _2sNsIgmnOE _23rrnHswLo _3vBAKHjOvk _3hxITi6wH8 _2V7sgO2M4S _3iDTPbvLZJ _1mT5xdRAKS _2O5Vij7dHp _0KLXrujOvk _1UtDYzy7kJ _0wOv4Q7zJH _0xmtko1Y8M _46hvQm1Y8M _03SyCP2AF2 _0LQT5E2AF2 _2fwxA5DIqT _1H5Ii9nXvL _2pF7Yy6wH8 _4ydpeVvc3e _1eOmH6o126 _0clgaMy7kJ _3sFUREDGiy _3gzVzLN4oS _0CMRbky7kJ",
                isSibling && "_23rrnHswLo _1UtDYzKGUX _0clgaMKGUX",
                isToday && "_1UtDYzjTy9 _1kk5Tkmb2E _4Gb5FivLZJ _47eTBt4Jdh _2WYcYGWVPG _3wEj0X98eZ _0GBAIrogpp _3ufiZDFQfX _3erkSQFQfX _13xWvlFQfX",
                isPreviouslySelected && "_23rrnHswLo _0KLXruY9q9 _1UtDYzZpcK _0clgaMZpcK",
                isSelected && "_23rrnHswLo _0KLXruY9q9 _1UtDYzjTy9 _1eOmH6sumd _0clgaMjTy9",
                isSelected && (0, $iDrrr.fg)('platform-dst-tokens-finesse') && "_23rrnHswLo _0KLXrukLmD _1UtDYze5R3 _1eOmH6XLOx _0clgaMe5R3 _3sFUREDGiy _3gzVzLPSfI _0CMRbke5R3",
                isDisabled && "_23rrnHswLo _1UtDYzot27 _0wOv4Qsyl5 _1eOmH6jOvk _0clgaMot27",
                (0, $iDrrr.fg)('platform-dst-motion-uplift-list-item') && "_23rrnHswLo _3t4LwpYbGa _1B4rbIswLo _3sFUREDGiy",
                (isSelected || isPreviouslySelected) && (0, $iDrrr.fg)('platform-dst-motion-uplift-list-item') && "_23rrnHzzT7"
            ]),
            children: day
        })
    });
}));
$c1121364af7966f7$var$Date.displayName = 'Date'; // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $c1121364af7966f7$export$2e2bcd8739ae039 = $c1121364af7966f7$var$Date;
module.exports["default"] = $c1121364af7966f7$export$2e2bcd8739ae039;

});

parcelRegister("4Xsrc", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $3pCca = parcelRequire("3pCca");

const $88589de4c2e0c04f$var$styles = {
    templateColumns: "_2iEGP2HVZM"
};
/**
 * __Week day grid__
 *
 * A week day grid aligns elements in a 7 wide grid layout.
 *
 */ const $88589de4c2e0c04f$var$WeekDayGrid = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { testId: testId, children: children, isHidden: isHidden } = t0;
    let t1;
    if ($[0] !== children || $[1] !== testId) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $3pCca.Grid), {
            testId: testId,
            xcss: $88589de4c2e0c04f$var$styles.templateColumns,
            role: "row",
            children: children
        });
        $[0] = children;
        $[1] = testId;
        $[2] = t1;
    } else t1 = $[2];
    const row = t1;
    let t2;
    if ($[3] !== isHidden || $[4] !== row) {
        t2 = isHidden ? /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            "aria-hidden": "true",
            children: row
        }) : row;
        $[3] = isHidden;
        $[4] = row;
        $[5] = t2;
    } else t2 = $[5];
    return t2;
} : ({ testId: testId, children: children, isHidden: isHidden })=>{
    const row = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $3pCca.Grid), {
        testId: testId,
        xcss: $88589de4c2e0c04f$var$styles.templateColumns,
        role: "row",
        children: children
    });
    return isHidden ? /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        "aria-hidden": "true",
        children: row
    }) : row;
};
var $88589de4c2e0c04f$export$2e2bcd8739ae039 = $88589de4c2e0c04f$var$WeekDayGrid;
module.exports["default"] = $88589de4c2e0c04f$export$2e2bcd8739ae039;

});

parcelRegister("RzcOF", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $iMnC5 = parcelRequire("iMnC5");

var $4aRua = parcelRequire("4aRua");


var $4Xsrc = parcelRequire("4Xsrc");

const $ce71262a5653464e$var$styles = {
    columnHeader: "_4ouGXIF6tL _1ANEUSLRg7 _3iDTPbQ4SZ _37wbyuDIqT"
};
const $ce71262a5653464e$var$WeekHeader = /*#__PURE__*/ (0, $cozmU.memo)((0, $gtMdU.isReactCompilerActivePlatform)() ? function WeekHeader(t0) {
    const $ = (0, $bDgLe.c)(8);
    const { daysShort: daysShort, testId: testId } = t0;
    const t1 = testId && `${testId}--column-headers`;
    let t2;
    if ($[0] !== daysShort || $[1] !== testId) {
        let t3;
        if ($[3] !== testId) {
            t3 = (shortDay)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                    padding: "space.100",
                    xcss: $ce71262a5653464e$var$styles.columnHeader,
                    role: "columnheader",
                    testId: testId && `${testId}--column-header`,
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                        weight: "bold",
                        size: "small",
                        align: "center",
                        color: "color.text.subtle",
                        children: shortDay
                    })
                }, shortDay);
            $[3] = testId;
            $[4] = t3;
        } else t3 = $[4];
        t2 = daysShort.map(t3);
        $[0] = daysShort;
        $[1] = testId;
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[5] !== t1 || $[6] !== t2) {
        t3 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4Xsrc.default), {
            isHidden: true,
            testId: t1,
            children: t2
        });
        $[5] = t1;
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
} : function WeekHeader({ daysShort: daysShort, testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4Xsrc.default), {
        isHidden: true,
        testId: testId && `${testId}--column-headers`,
        children: daysShort.map((shortDay)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                padding: "space.100",
                xcss: $ce71262a5653464e$var$styles.columnHeader,
                role: "columnheader",
                testId: testId && `${testId}--column-header`,
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                    weight: "bold",
                    size: "small",
                    align: "center",
                    color: "color.text.subtle",
                    children: shortDay
                })
            }, shortDay))
    });
});
$ce71262a5653464e$var$WeekHeader.displayName = 'WeekHeader'; // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $ce71262a5653464e$export$2e2bcd8739ae039 = $ce71262a5653464e$var$WeekHeader;
module.exports["default"] = $ce71262a5653464e$export$2e2bcd8739ae039;

});

parcelRegister("2lTKb", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $5Dlqn = parcelRequire("5Dlqn");


var $4U9wy = parcelRequire("4U9wy");


var $5XHJF = parcelRequire("5XHJF");

// eslint-disable-next-line @repo/internal/react/require-jsdoc
const $30f093e39d878d3b$var$useControlledDateState = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useControlledDateState(t0) {
    const $ = (0, $bDgLe.c)(42);
    const { day: day, defaultDay: defaultDay, month: month, defaultMonth: defaultMonth, year: year, defaultYear: defaultYear, today: today, selected: selected, defaultSelected: defaultSelected, previouslySelected: previouslySelected, defaultPreviouslySelected: defaultPreviouslySelected } = t0;
    const { current: t1 } = (0, $4U9wy.default)($30f093e39d878d3b$var$_temp);
    const { thisDay: thisDay_0, thisMonth: thisMonth_0, thisYear: thisYear_0 } = t1;
    let t2;
    if ($[0] !== defaultDay || $[1] !== thisDay_0) {
        t2 = ()=>defaultDay || thisDay_0;
        $[0] = defaultDay;
        $[1] = thisDay_0;
        $[2] = t2;
    } else t2 = $[2];
    const [dayValue, setDayValue] = (0, $5Dlqn.default)(day, t2);
    let t3;
    if ($[3] !== defaultMonth || $[4] !== thisMonth_0) {
        t3 = ()=>defaultMonth || thisMonth_0;
        $[3] = defaultMonth;
        $[4] = thisMonth_0;
        $[5] = t3;
    } else t3 = $[5];
    const [monthValue, setMonthValue] = (0, $5Dlqn.default)(month, t3);
    let t4;
    if ($[6] !== defaultYear || $[7] !== thisYear_0) {
        t4 = ()=>defaultYear || thisYear_0;
        $[6] = defaultYear;
        $[7] = thisYear_0;
        $[8] = t4;
    } else t4 = $[8];
    const [yearValue, setYearValue] = (0, $5Dlqn.default)(year, t4);
    let t5;
    if ($[9] !== thisDay_0 || $[10] !== thisMonth_0 || $[11] !== thisYear_0 || $[12] !== today) {
        t5 = ()=>today || `${thisYear_0}-${(0, $5XHJF.default)(thisMonth_0)}-${(0, $5XHJF.default)(thisDay_0)}`;
        $[9] = thisDay_0;
        $[10] = thisMonth_0;
        $[11] = thisYear_0;
        $[12] = today;
        $[13] = t5;
    } else t5 = $[13];
    const [todayValue] = (0, $5Dlqn.default)(today, t5);
    let t6;
    if ($[14] !== defaultSelected) {
        t6 = ()=>defaultSelected;
        $[14] = defaultSelected;
        $[15] = t6;
    } else t6 = $[15];
    const [selectedValue, setSelectedValue] = (0, $5Dlqn.default)(selected, t6);
    let t7;
    if ($[16] !== defaultPreviouslySelected) {
        t7 = ()=>defaultPreviouslySelected;
        $[16] = defaultPreviouslySelected;
        $[17] = t7;
    } else t7 = $[17];
    const [previouslySelectedValue, setPreviouslySelectedValue] = (0, $5Dlqn.default)(previouslySelected, t7);
    let t8;
    if ($[18] !== dayValue || $[19] !== setDayValue) {
        t8 = [
            dayValue,
            setDayValue
        ];
        $[18] = dayValue;
        $[19] = setDayValue;
        $[20] = t8;
    } else t8 = $[20];
    let t9;
    if ($[21] !== monthValue || $[22] !== setMonthValue) {
        t9 = [
            monthValue,
            setMonthValue
        ];
        $[21] = monthValue;
        $[22] = setMonthValue;
        $[23] = t9;
    } else t9 = $[23];
    let t10;
    if ($[24] !== setYearValue || $[25] !== yearValue) {
        t10 = [
            yearValue,
            setYearValue
        ];
        $[24] = setYearValue;
        $[25] = yearValue;
        $[26] = t10;
    } else t10 = $[26];
    let t11;
    if ($[27] !== todayValue) {
        t11 = [
            todayValue
        ];
        $[27] = todayValue;
        $[28] = t11;
    } else t11 = $[28];
    let t12;
    if ($[29] !== selectedValue || $[30] !== setSelectedValue) {
        t12 = [
            selectedValue,
            setSelectedValue
        ];
        $[29] = selectedValue;
        $[30] = setSelectedValue;
        $[31] = t12;
    } else t12 = $[31];
    let t13;
    if ($[32] !== previouslySelectedValue || $[33] !== setPreviouslySelectedValue) {
        t13 = [
            previouslySelectedValue,
            setPreviouslySelectedValue
        ];
        $[32] = previouslySelectedValue;
        $[33] = setPreviouslySelectedValue;
        $[34] = t13;
    } else t13 = $[34];
    let t14;
    if ($[35] !== t10 || $[36] !== t11 || $[37] !== t12 || $[38] !== t13 || $[39] !== t8 || $[40] !== t9) {
        t14 = {
            day: t8,
            month: t9,
            year: t10,
            today: t11,
            selected: t12,
            previous: t13
        };
        $[35] = t10;
        $[36] = t11;
        $[37] = t12;
        $[38] = t13;
        $[39] = t8;
        $[40] = t9;
        $[41] = t14;
    } else t14 = $[41];
    return t14;
} : function useControlledDateState({ day: day, defaultDay: defaultDay, month: month, defaultMonth: defaultMonth, year: year, defaultYear: defaultYear, today: today, selected: selected, defaultSelected: defaultSelected, previouslySelected: previouslySelected, defaultPreviouslySelected: defaultPreviouslySelected }) {
    const { current: { thisDay: thisDay_0, thisMonth: thisMonth_0, thisYear: thisYear_0 } } = (0, $4U9wy.default)(()=>{
        const now = new Date();
        const thisDay = now.getDate();
        const thisMonth = now.getMonth() + 1;
        const thisYear = now.getFullYear();
        return {
            thisDay: thisDay,
            thisMonth: thisMonth,
            thisYear: thisYear
        };
    });
    const [dayValue, setDayValue] = (0, $5Dlqn.default)(day, ()=>defaultDay || thisDay_0);
    const [monthValue, setMonthValue] = (0, $5Dlqn.default)(month, ()=>defaultMonth || thisMonth_0);
    const [yearValue, setYearValue] = (0, $5Dlqn.default)(year, ()=>defaultYear || thisYear_0);
    const [todayValue] = (0, $5Dlqn.default)(today, ()=>today || `${thisYear_0}-${(0, $5XHJF.default)(thisMonth_0)}-${(0, $5XHJF.default)(thisDay_0)}`);
    const [selectedValue, setSelectedValue] = (0, $5Dlqn.default)(selected, ()=>defaultSelected);
    const [previouslySelectedValue, setPreviouslySelectedValue] = (0, $5Dlqn.default)(previouslySelected, ()=>defaultPreviouslySelected);
    return {
        day: [
            dayValue,
            setDayValue
        ],
        month: [
            monthValue,
            setMonthValue
        ],
        year: [
            yearValue,
            setYearValue
        ],
        today: [
            todayValue
        ],
        selected: [
            selectedValue,
            setSelectedValue
        ],
        previous: [
            previouslySelectedValue,
            setPreviouslySelectedValue
        ]
    };
};
var $30f093e39d878d3b$export$2e2bcd8739ae039 = $30f093e39d878d3b$var$useControlledDateState;
function $30f093e39d878d3b$var$_temp() {
    const now = new Date();
    const thisDay = now.getDate();
    const thisMonth = now.getMonth() + 1;
    const thisYear = now.getFullYear();
    return {
        thisDay: thisDay,
        thisMonth: thisMonth,
        thisYear: thisYear
    };
}
module.exports["default"] = $30f093e39d878d3b$export$2e2bcd8739ae039;

});

parcelRegister("5XHJF", function(module, exports) {
$parcel$export(module.exports, "default", () => $d7b9101ab01e01cd$export$2e2bcd8739ae039);
function $d7b9101ab01e01cd$export$2e2bcd8739ae039(num) {
    return num < 10 ? `0${num}` : `${num}`;
}

});

parcelRegister("669cn", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

// eslint-disable-next-line @repo/internal/react/require-jsdoc
const $702ccecd4f852bb0$var$useFocusing = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useFocusing(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { onBlur: onBlur, onFocus: onFocus } = t0;
    let t1;
    if ($[0] !== onBlur) {
        t1 = (event)=>{
            onBlur(event);
        };
        $[0] = onBlur;
        $[1] = t1;
    } else t1 = $[1];
    const handleContainerBlur = t1;
    let t2;
    if ($[2] !== onFocus) {
        t2 = (event_0)=>{
            onFocus(event_0);
        };
        $[2] = onFocus;
        $[3] = t2;
    } else t2 = $[3];
    const handleContainerFocus = t2;
    let t3;
    if ($[4] !== handleContainerBlur || $[5] !== handleContainerFocus) {
        t3 = {
            handleContainerBlur: handleContainerBlur,
            handleContainerFocus: handleContainerFocus
        };
        $[4] = handleContainerBlur;
        $[5] = handleContainerFocus;
        $[6] = t3;
    } else t3 = $[6];
    return t3;
} : function useFocusing({ onBlur: onBlur, onFocus: onFocus }) {
    const handleContainerBlur = (0, $cozmU.useCallback)((event)=>{
        onBlur(event);
    }, [
        onBlur
    ]);
    const handleContainerFocus = (0, $cozmU.useCallback)((event_0)=>{
        onFocus(event_0);
    }, [
        onFocus
    ]);
    return {
        handleContainerBlur: handleContainerBlur,
        handleContainerFocus: handleContainerFocus
    };
};
var $702ccecd4f852bb0$export$2e2bcd8739ae039 = $702ccecd4f852bb0$var$useFocusing;
module.exports["default"] = $702ccecd4f852bb0$export$2e2bcd8739ae039;

});

parcelRegister("lq3dZ", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $k5sGX = parcelRequire("k5sGX");


var $aviSf = parcelRequire("aviSf");


var $blHSj = parcelRequire("blHSj");


var $bAYvJ = parcelRequire("bAYvJ");

const $5a1ed6accae25dc2$var$useGetCalendarWithSixthWeek = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useGetCalendarWithSixthWeek(calendar, t0) {
    const $ = (0, $bDgLe.c)(6);
    const { month: month, year: year, weekStartDay: weekStartDay } = t0;
    const shouldDisplaySixthWeek = calendar.length % 6;
    const calendarLastValue = calendar[calendar.length - 1];
    let t1;
    bb0: {
        if (shouldDisplaySixthWeek) {
            const lastDayIsSibling = calendarLastValue.siblingMonth;
            const sliceStart = lastDayIsSibling ? (0, $aviSf.daysPerWeek) : 0;
            let t2;
            if ($[0] !== month || $[1] !== sliceStart || $[2] !== weekStartDay || $[3] !== year) {
                t2 = (0, $bAYvJ.default)(year, month, {
                    weekStartDay: weekStartDay
                }).slice(sliceStart, sliceStart + (0, $aviSf.daysPerWeek)).map($5a1ed6accae25dc2$var$_temp);
                $[0] = month;
                $[1] = sliceStart;
                $[2] = weekStartDay;
                $[3] = year;
                $[4] = t2;
            } else t2 = $[4];
            t1 = t2;
            break bb0;
        }
        let t2;
        if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
            t2 = [];
            $[5] = t2;
        } else t2 = $[5];
        t1 = t2;
    }
    return t1;
} : function useGetCalendarWithSixthWeek(calendar, { month: month, year: year, weekStartDay: weekStartDay }) {
    const shouldDisplaySixthWeek = calendar.length % 6;
    const calendarLastValue = calendar[calendar.length - 1];
    return (0, $cozmU.useMemo)(()=>{
        // Some months jump between 5 and 6 weeks to display. In some cases 4 (Feb
        // with the 1st on a Monday etc). This ensures the UI doesn't jump around by
        // catering to always showing 6 weeks.
        if (shouldDisplaySixthWeek) {
            const lastDayIsSibling = calendarLastValue.siblingMonth;
            const sliceStart = lastDayIsSibling ? (0, $aviSf.daysPerWeek) : 0;
            return (0, $bAYvJ.default)(year, month, {
                weekStartDay: weekStartDay
            }).slice(sliceStart, sliceStart + (0, $aviSf.daysPerWeek)).map((date)=>({
                    ...date,
                    siblingMonth: true
                }));
        }
        return [];
    }, [
        calendarLastValue,
        month,
        shouldDisplaySixthWeek,
        weekStartDay,
        year
    ]);
}; // eslint-disable-next-line @repo/internal/react/require-jsdoc
function $5a1ed6accae25dc2$var$_temp(date) {
    return {
        ...date,
        siblingMonth: true
    };
}
const $5a1ed6accae25dc2$var$useGetWeeks = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useGetWeeks(t0) {
    const $ = (0, $bDgLe.c)(25);
    const { day: day, daysLong: daysLong, month: month, year: year, today: today, disabled: disabled, disabledDateFilter: disabledDateFilter, minDate: minDateString, maxDate: maxDateString, selected: selected, previouslySelected: previouslySelected, weekStartDay: weekStartDay } = t0;
    const t1 = month - 1;
    let t2;
    if ($[0] !== t1 || $[1] !== weekStartDay || $[2] !== year) {
        t2 = (0, $bAYvJ.default)(year, t1, {
            weekStartDay: weekStartDay
        });
        $[0] = t1;
        $[1] = weekStartDay;
        $[2] = year;
        $[3] = t2;
    } else t2 = $[3];
    const calendar = t2;
    let t3;
    if ($[4] !== month || $[5] !== weekStartDay || $[6] !== year) {
        t3 = {
            month: month,
            year: year,
            weekStartDay: weekStartDay
        };
        $[4] = month;
        $[5] = weekStartDay;
        $[6] = year;
        $[7] = t3;
    } else t3 = $[7];
    const calendarWithSixthWeek = $5a1ed6accae25dc2$var$useGetCalendarWithSixthWeek(calendar, t3);
    if (calendarWithSixthWeek) calendar.push(...calendarWithSixthWeek);
    let t4;
    if ($[8] !== minDateString) {
        t4 = minDateString ? (0, $k5sGX.default)(minDateString) : undefined;
        $[8] = minDateString;
        $[9] = t4;
    } else t4 = $[9];
    const minDate = t4;
    let t5;
    if ($[10] !== maxDateString) {
        t5 = maxDateString ? (0, $k5sGX.default)(maxDateString) : undefined;
        $[10] = maxDateString;
        $[11] = t5;
    } else t5 = $[11];
    const maxDate = t5;
    const needJsDate = minDateString || maxDateString;
    let weeks;
    if ($[12] !== calendar || $[13] !== day || $[14] !== daysLong || $[15] !== disabled || $[16] !== disabledDateFilter || $[17] !== maxDate || $[18] !== minDate || $[19] !== needJsDate || $[20] !== previouslySelected || $[21] !== selected || $[22] !== today || $[23] !== weekStartDay) {
        weeks = [];
        calendar.forEach((date)=>{
            const dateAsString = (0, $blHSj.default)(date, {
                fixMonth: true
            });
            const JSDate = needJsDate ? (0, $k5sGX.default)(dateAsString) : undefined;
            let week;
            if (date.weekDay === weekStartDay) {
                week = {
                    id: dateAsString,
                    values: []
                };
                weeks.push(week);
            } else week = weeks[weeks.length - 1];
            const weekDayOffset = (date.weekDay - weekStartDay) % 7;
            const weekDayName = daysLong[weekDayOffset];
            const isDisabledByArray = disabled ? disabled.indexOf(dateAsString) > -1 : false;
            const isDisabledByFilter = disabledDateFilter ? disabledDateFilter(dateAsString) : false;
            const isDisabledByMin = minDate && JSDate ? JSDate < minDate : false;
            const isDisabledByMax = maxDate && JSDate ? JSDate > maxDate : false;
            const isDisabled = isDisabledByArray || isDisabledByFilter || isDisabledByMin || isDisabledByMax;
            const isFocused = day === date.day && !date.siblingMonth;
            const isPreviouslySelected = !isDisabled && previouslySelected.indexOf(dateAsString) > -1;
            const isSelected = !isDisabled && selected.indexOf(dateAsString) > -1;
            const isSiblingMonth = !!date.siblingMonth;
            const isToday = today === dateAsString;
            week.values.push({
                id: dateAsString,
                isDisabled: isDisabled,
                isFocused: isFocused,
                isToday: isToday,
                month: date.month + 1,
                isPreviouslySelected: isPreviouslySelected,
                isSelected: isSelected,
                isSiblingMonth: isSiblingMonth,
                year: date.year,
                day: date.day,
                weekDayName: weekDayName
            });
        });
        $[12] = calendar;
        $[13] = day;
        $[14] = daysLong;
        $[15] = disabled;
        $[16] = disabledDateFilter;
        $[17] = maxDate;
        $[18] = minDate;
        $[19] = needJsDate;
        $[20] = previouslySelected;
        $[21] = selected;
        $[22] = today;
        $[23] = weekStartDay;
        $[24] = weeks;
    } else weeks = $[24];
    return weeks;
} : function useGetWeeks({ day: day, daysLong: daysLong, month: month, year: year, today: today, disabled: disabled, disabledDateFilter: disabledDateFilter, minDate: minDateString, maxDate: maxDateString, selected: selected, previouslySelected: previouslySelected, weekStartDay: weekStartDay }) {
    const calendar = (0, $cozmU.useMemo)(()=>(0, $bAYvJ.default)(year, month - 1, {
            weekStartDay: weekStartDay
        }), [
        month,
        weekStartDay,
        year
    ]);
    const calendarWithSixthWeek = $5a1ed6accae25dc2$var$useGetCalendarWithSixthWeek(calendar, {
        month: month,
        year: year,
        weekStartDay: weekStartDay
    });
    if (calendarWithSixthWeek) calendar.push(...calendarWithSixthWeek);
    const minDate = minDateString ? (0, $k5sGX.default)(minDateString) : undefined;
    const maxDate = maxDateString ? (0, $k5sGX.default)(maxDateString) : undefined;
    const needJsDate = minDateString || maxDateString;
    return (0, $cozmU.useMemo)(()=>{
        const weeks = [];
        calendar.forEach((date)=>{
            const dateAsString = (0, $blHSj.default)(date, {
                fixMonth: true
            });
            const JSDate = needJsDate ? (0, $k5sGX.default)(dateAsString) : undefined;
            let week;
            if (date.weekDay === weekStartDay) {
                week = {
                    id: dateAsString,
                    values: []
                };
                weeks.push(week);
            } else week = weeks[weeks.length - 1];
            const weekDayOffset = (date.weekDay - weekStartDay) % 7;
            // Define a bunch of `const`s
            const weekDayName = daysLong[weekDayOffset];
            const isDisabledByArray = disabled ? disabled.indexOf(dateAsString) > -1 : false;
            const isDisabledByFilter = disabledDateFilter ? disabledDateFilter(dateAsString) : false;
            const isDisabledByMin = minDate && JSDate ? JSDate < minDate : false;
            const isDisabledByMax = maxDate && JSDate ? JSDate > maxDate : false;
            const isDisabled = isDisabledByArray || isDisabledByFilter || isDisabledByMin || isDisabledByMax;
            const isFocused = day === date.day && !date.siblingMonth;
            const isPreviouslySelected = !isDisabled && previouslySelected.indexOf(dateAsString) > -1;
            const isSelected = !isDisabled && selected.indexOf(dateAsString) > -1;
            const isSiblingMonth = !!date.siblingMonth;
            const isToday = today === dateAsString;
            week.values.push({
                id: dateAsString,
                isDisabled: isDisabled,
                isFocused: isFocused,
                isToday: isToday,
                month: date.month + 1,
                isPreviouslySelected: isPreviouslySelected,
                isSelected: isSelected,
                isSiblingMonth: isSiblingMonth,
                year: date.year,
                day: date.day,
                weekDayName: weekDayName
            });
        });
        return weeks;
    }, [
        calendar,
        day,
        disabled,
        disabledDateFilter,
        minDate,
        maxDate,
        needJsDate,
        previouslySelected,
        selected,
        today,
        weekStartDay,
        daysLong
    ]);
};
var $5a1ed6accae25dc2$export$2e2bcd8739ae039 = $5a1ed6accae25dc2$var$useGetWeeks;
module.exports["default"] = $5a1ed6accae25dc2$export$2e2bcd8739ae039;

});

parcelRegister("aviSf", function(module, exports) {
const $b38b8178c69eabf7$export$3ae905d9742bef55 = 7;
const $b38b8178c69eabf7$export$c9b7c010035d60c6 = 12;
module.exports["daysPerWeek"] = $b38b8178c69eabf7$export$3ae905d9742bef55;
module.exports["monthsPerYear"] = $b38b8178c69eabf7$export$c9b7c010035d60c6;

});

parcelRegister("blHSj", function(module, exports) {
$parcel$export(module.exports, "default", () => $330dc868cc8fcda9$export$2e2bcd8739ae039);

var $5XHJF = parcelRequire("5XHJF");

function $330dc868cc8fcda9$export$2e2bcd8739ae039(date, options) {
    return `${date.year}-${(0, $5XHJF.default)(date.month + (options && options.fixMonth ? 1 : 0))}-${(0, $5XHJF.default)(date.day)}`;
}

});

parcelRegister("bAYvJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $1abf4bb131f576af$export$2e2bcd8739ae039);
/**
 * Logic taken from https://github.com/WesSouza/calendar-base which is not maintained for quite sometime.
 * This will help us fixing any issue we might get or any new functionality we might want to support.
 * Not changing much code below. Just removed those parts which we don't need.
 */ 
var $aviSf = parcelRequire("aviSf");


var $9PMdq = parcelRequire("9PMdq");

function $1abf4bb131f576af$export$2e2bcd8739ae039(year, month, { weekStartDay: weekStartDay = 0 } = {
    weekStartDay: 0
}) {
    const date = new Date(Date.UTC(year, month, 1, 0, 0, 0, 0));
    const utcYear = date.getUTCFullYear();
    const utcMonth = date.getUTCMonth();
    const calendar = [];
    const firstDay = date.getUTCDay();
    const firstDate = -(((0, $aviSf.daysPerWeek) - weekStartDay + firstDay) % (0, $aviSf.daysPerWeek));
    const lastDate = (0, $9PMdq.default)(utcYear, utcMonth);
    const lastDay = (lastDate - firstDate) % (0, $aviSf.daysPerWeek);
    const lastDateOfPreviousMonth = (0, $9PMdq.default)(utcYear, utcMonth - 1);
    let dateCounter = firstDate;
    let currentDay;
    let currentDate;
    let currentDateObject = null;
    let calculatedMonth;
    let calculatedYear;
    const maxDateCount = lastDate - dateCounter + (lastDay !== 0 ? (0, $aviSf.daysPerWeek) - lastDay : 0) + firstDate;
    while(dateCounter < maxDateCount){
        currentDate = dateCounter + 1;
        currentDay = ((dateCounter < 1 ? (0, $aviSf.daysPerWeek) + dateCounter : dateCounter) + firstDay) % (0, $aviSf.daysPerWeek);
        if (currentDate < 1 || currentDate > lastDate) {
            if (currentDate < 1) {
                calculatedMonth = utcMonth - 1;
                calculatedYear = utcYear;
                if (calculatedMonth < 0) {
                    calculatedMonth = (0, $aviSf.monthsPerYear) - 1;
                    calculatedYear--;
                }
                currentDate = lastDateOfPreviousMonth + currentDate;
            } else if (currentDate > lastDate) {
                calculatedMonth = utcMonth + 1;
                calculatedYear = utcYear;
                if (calculatedMonth > (0, $aviSf.monthsPerYear) - 1) {
                    calculatedMonth = 0;
                    calculatedYear++;
                }
                currentDate = dateCounter - lastDate + 1;
            }
            if (calculatedMonth !== undefined && calculatedYear !== undefined) currentDateObject = {
                day: currentDate,
                weekDay: currentDay,
                month: calculatedMonth,
                year: calculatedYear,
                siblingMonth: true
            };
        } else currentDateObject = {
            day: currentDate,
            weekDay: currentDay,
            month: utcMonth,
            year: utcYear
        };
        calendar.push(currentDateObject);
        dateCounter++;
    }
    return calendar;
}

});

parcelRegister("9PMdq", function(module, exports) {
$parcel$export(module.exports, "default", () => $0a9cb6917d411474$export$2e2bcd8739ae039);
function $0a9cb6917d411474$export$2e2bcd8739ae039(year, month) {
    return new Date(year, month + 1, 0).getDate();
}

});

parcelRegister("2NGTx", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $aviSf = parcelRequire("aviSf");


var $blHSj = parcelRequire("blHSj");


var $9PMdq = parcelRequire("9PMdq");

const $0dcfeb64fb14a2d7$var$getNextMonth = (monthValue, yearValue)=>{
    let month = monthValue;
    let year = yearValue;
    if (month === (0, $aviSf.monthsPerYear)) {
        month = 1;
        year += 1;
    } else month += 1;
    return {
        month: month,
        year: year
    };
};
const $0dcfeb64fb14a2d7$var$getPrevMonth = (monthValue, yearValue)=>{
    let month = monthValue;
    let year = yearValue;
    if (month === 1) {
        month = (0, $aviSf.monthsPerYear);
        year -= 1;
    } else month -= 1;
    return {
        month: month,
        year: year
    };
};
// eslint-disable-next-line @repo/internal/react/require-jsdoc
const $0dcfeb64fb14a2d7$var$useHandleDateChange = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useHandleDateChange(t0) {
    const $ = (0, $bDgLe.c)(31);
    const { day: t1, month: t2, year: t3, shouldSetFocus: t4, onChange: onChange } = t0;
    const [dayValue, setDayValue] = t1;
    const [monthValue, setMonthValue] = t2;
    const [yearValue, setYearValue] = t3;
    const [, setShouldSetFocus] = t4;
    let t5;
    if ($[0] !== dayValue || $[1] !== monthValue || $[2] !== yearValue) {
        t5 = {
            day: dayValue,
            month: monthValue,
            year: yearValue
        };
        $[0] = dayValue;
        $[1] = monthValue;
        $[2] = yearValue;
        $[3] = t5;
    } else t5 = $[3];
    const dateRef = (0, $cozmU.useRef)(t5);
    let t6;
    let t7;
    if ($[4] !== dayValue || $[5] !== monthValue || $[6] !== yearValue) {
        t6 = ()=>{
            dateRef.current = {
                day: dayValue,
                month: monthValue,
                year: yearValue
            };
        };
        t7 = [
            dayValue,
            monthValue,
            yearValue
        ];
        $[4] = dayValue;
        $[5] = monthValue;
        $[6] = yearValue;
        $[7] = t6;
        $[8] = t7;
    } else {
        t6 = $[7];
        t7 = $[8];
    }
    (0, $cozmU.useEffect)(t6, t7);
    let t8;
    if ($[9] !== onChange || $[10] !== setDayValue || $[11] !== setMonthValue || $[12] !== setShouldSetFocus || $[13] !== setYearValue) {
        t8 = (t9)=>{
            const { year: year, month: month, day: day, type: type } = t9;
            const iso = (0, $blHSj.default)({
                year: year,
                month: month,
                day: day
            });
            const isFocusableType = [
                "up",
                "down",
                "left",
                "right"
            ].includes(type);
            onChange({
                day: day,
                month: month,
                year: year,
                iso: iso,
                type: type
            });
            setDayValue(day);
            setMonthValue(month);
            setYearValue(year);
            setShouldSetFocus(isFocusableType);
        };
        $[9] = onChange;
        $[10] = setDayValue;
        $[11] = setMonthValue;
        $[12] = setShouldSetFocus;
        $[13] = setYearValue;
        $[14] = t8;
    } else t8 = $[14];
    const triggerOnChange = t8;
    let t9;
    if ($[15] !== triggerOnChange) {
        t9 = (type_0)=>{
            const { day: day_0, month: month_0, year: year_0 } = dateRef.current;
            if (type_0 === "down") {
                const next = day_0 + (0, $aviSf.daysPerWeek);
                const daysInMonth = (0, $9PMdq.default)(year_0, month_0 - 1);
                if (next > daysInMonth) {
                    const { month: nextMonth, year: nextYear } = $0dcfeb64fb14a2d7$var$getNextMonth(month_0, year_0);
                    triggerOnChange({
                        year: nextYear,
                        month: nextMonth,
                        day: next - daysInMonth,
                        type: type_0
                    });
                } else triggerOnChange({
                    year: year_0,
                    month: month_0,
                    day: next,
                    type: type_0
                });
            } else if (type_0 === "left") {
                const prev = day_0 - 1;
                if (prev < 1) {
                    const { month: prevMonth, year: prevYear } = $0dcfeb64fb14a2d7$var$getPrevMonth(month_0, year_0);
                    const prevDay = (0, $9PMdq.default)(prevYear, prevMonth - 1);
                    triggerOnChange({
                        year: prevYear,
                        month: prevMonth,
                        day: prevDay,
                        type: type_0
                    });
                } else triggerOnChange({
                    year: year_0,
                    month: month_0,
                    day: prev,
                    type: type_0
                });
            } else {
                if (type_0 === "right") {
                    const next_0 = day_0 + 1;
                    const daysInMonth_0 = (0, $9PMdq.default)(year_0, month_0 - 1);
                    if (next_0 > daysInMonth_0) {
                        const { month: nextMonth_0, year: nextYear_0 } = $0dcfeb64fb14a2d7$var$getNextMonth(month_0, year_0);
                        triggerOnChange({
                            year: nextYear_0,
                            month: nextMonth_0,
                            day: 1,
                            type: type_0
                        });
                    } else triggerOnChange({
                        year: year_0,
                        month: month_0,
                        day: next_0,
                        type: type_0
                    });
                } else if (type_0 === "up") {
                    const prev_0 = day_0 - (0, $aviSf.daysPerWeek);
                    if (prev_0 < 1) {
                        const { month: prevMonth_0, year: prevYear_0 } = $0dcfeb64fb14a2d7$var$getPrevMonth(month_0, year_0);
                        const prevDay_0 = (0, $9PMdq.default)(prevYear_0, prevMonth_0 - 1) + prev_0;
                        triggerOnChange({
                            year: prevYear_0,
                            month: prevMonth_0,
                            day: prevDay_0,
                            type: type_0
                        });
                    } else triggerOnChange({
                        year: year_0,
                        month: month_0,
                        day: prev_0,
                        type: type_0
                    });
                }
            }
        };
        $[15] = triggerOnChange;
        $[16] = t9;
    } else t9 = $[16];
    const navigate = t9;
    let t10;
    if ($[17] !== triggerOnChange) {
        t10 = ()=>{
            const { day: day_1, month: month_1, year: year_1 } = {
                ...dateRef.current,
                ...$0dcfeb64fb14a2d7$var$getNextMonth(dateRef.current.month, dateRef.current.year)
            };
            triggerOnChange({
                day: day_1,
                month: month_1,
                year: year_1,
                type: "nextMonth"
            });
        };
        $[17] = triggerOnChange;
        $[18] = t10;
    } else t10 = $[18];
    const handleClickNextMonth = t10;
    let t11;
    if ($[19] !== triggerOnChange) {
        t11 = ()=>{
            const { day: day_2, month: month_2, year: year_2 } = dateRef.current;
            triggerOnChange({
                day: day_2,
                month: month_2,
                year: year_2 + 1,
                type: "nextYear"
            });
        };
        $[19] = triggerOnChange;
        $[20] = t11;
    } else t11 = $[20];
    const handleClickNextYear = t11;
    let t12;
    if ($[21] !== triggerOnChange) {
        t12 = ()=>{
            const { day: day_3, month: month_3, year: year_3 } = {
                ...dateRef.current,
                ...$0dcfeb64fb14a2d7$var$getPrevMonth(dateRef.current.month, dateRef.current.year)
            };
            triggerOnChange({
                day: day_3,
                month: month_3,
                year: year_3,
                type: "prevMonth"
            });
        };
        $[21] = triggerOnChange;
        $[22] = t12;
    } else t12 = $[22];
    const handleClickPrevMonth = t12;
    let t13;
    if ($[23] !== triggerOnChange) {
        t13 = ()=>{
            const { day: day_4, month: month_4, year: year_4 } = dateRef.current;
            triggerOnChange({
                day: day_4,
                month: month_4,
                year: year_4 - 1,
                type: "prevYear"
            });
        };
        $[23] = triggerOnChange;
        $[24] = t13;
    } else t13 = $[24];
    const handleClickPrevYear = t13;
    let t14;
    if ($[25] !== handleClickNextMonth || $[26] !== handleClickNextYear || $[27] !== handleClickPrevMonth || $[28] !== handleClickPrevYear || $[29] !== navigate) {
        t14 = {
            navigate: navigate,
            handleClickNextMonth: handleClickNextMonth,
            handleClickNextYear: handleClickNextYear,
            handleClickPrevMonth: handleClickPrevMonth,
            handleClickPrevYear: handleClickPrevYear
        };
        $[25] = handleClickNextMonth;
        $[26] = handleClickNextYear;
        $[27] = handleClickPrevMonth;
        $[28] = handleClickPrevYear;
        $[29] = navigate;
        $[30] = t14;
    } else t14 = $[30];
    return t14;
} : function useHandleDateChange({ day: [dayValue, setDayValue], month: [monthValue, setMonthValue], year: [yearValue, setYearValue], shouldSetFocus: [_shouldSetFocus, setShouldSetFocus], onChange: onChange }) {
    const dateRef = (0, $cozmU.useRef)({
        day: dayValue,
        month: monthValue,
        year: yearValue
    });
    (0, $cozmU.useEffect)(()=>{
        dateRef.current = {
            day: dayValue,
            month: monthValue,
            year: yearValue
        };
    }, [
        dayValue,
        monthValue,
        yearValue
    ]);
    const triggerOnChange = (0, $cozmU.useCallback)(({ year: year, month: month, day: day, type: type })=>{
        const iso = (0, $blHSj.default)({
            year: year,
            month: month,
            day: day
        });
        const isFocusableType = [
            'up',
            'down',
            'left',
            'right'
        ].includes(type);
        onChange({
            day: day,
            month: month,
            year: year,
            iso: iso,
            type: type
        });
        setDayValue(day);
        setMonthValue(month);
        setYearValue(year);
        setShouldSetFocus(isFocusableType);
    }, [
        onChange,
        setDayValue,
        setMonthValue,
        setYearValue,
        setShouldSetFocus
    ]);
    const navigate = (0, $cozmU.useCallback)((type_0)=>{
        const { day: day_0, month: month_0, year: year_0 } = dateRef.current;
        if (type_0 === 'down') {
            const next = day_0 + (0, $aviSf.daysPerWeek);
            const daysInMonth = (0, $9PMdq.default)(year_0, month_0 - 1);
            if (next > daysInMonth) {
                const { month: nextMonth, year: nextYear } = $0dcfeb64fb14a2d7$var$getNextMonth(month_0, year_0);
                triggerOnChange({
                    year: nextYear,
                    month: nextMonth,
                    day: next - daysInMonth,
                    type: type_0
                });
            } else triggerOnChange({
                year: year_0,
                month: month_0,
                day: next,
                type: type_0
            });
        } else if (type_0 === 'left') {
            const prev = day_0 - 1;
            if (prev < 1) {
                const { month: prevMonth, year: prevYear } = $0dcfeb64fb14a2d7$var$getPrevMonth(month_0, year_0);
                const prevDay = (0, $9PMdq.default)(prevYear, prevMonth - 1);
                triggerOnChange({
                    year: prevYear,
                    month: prevMonth,
                    day: prevDay,
                    type: type_0
                });
            } else triggerOnChange({
                year: year_0,
                month: month_0,
                day: prev,
                type: type_0
            });
        } else if (type_0 === 'right') {
            const next_0 = day_0 + 1;
            const daysInMonth_0 = (0, $9PMdq.default)(year_0, month_0 - 1);
            if (next_0 > daysInMonth_0) {
                const { month: nextMonth_0, year: nextYear_0 } = $0dcfeb64fb14a2d7$var$getNextMonth(month_0, year_0);
                triggerOnChange({
                    year: nextYear_0,
                    month: nextMonth_0,
                    day: 1,
                    type: type_0
                });
            } else triggerOnChange({
                year: year_0,
                month: month_0,
                day: next_0,
                type: type_0
            });
        } else if (type_0 === 'up') {
            const prev_0 = day_0 - (0, $aviSf.daysPerWeek);
            if (prev_0 < 1) {
                const { month: prevMonth_0, year: prevYear_0 } = $0dcfeb64fb14a2d7$var$getPrevMonth(month_0, year_0);
                const prevDay_0 = (0, $9PMdq.default)(prevYear_0, prevMonth_0 - 1) + prev_0;
                triggerOnChange({
                    year: prevYear_0,
                    month: prevMonth_0,
                    day: prevDay_0,
                    type: type_0
                });
            } else triggerOnChange({
                year: year_0,
                month: month_0,
                day: prev_0,
                type: type_0
            });
        }
    }, [
        triggerOnChange
    ]);
    const handleClickNextMonth = (0, $cozmU.useCallback)(()=>{
        const { day: day_1, month: month_1, year: year_1 } = {
            ...dateRef.current,
            ...$0dcfeb64fb14a2d7$var$getNextMonth(dateRef.current.month, dateRef.current.year)
        };
        triggerOnChange({
            day: day_1,
            month: month_1,
            year: year_1,
            type: 'nextMonth'
        });
    }, [
        triggerOnChange
    ]);
    const handleClickNextYear = (0, $cozmU.useCallback)(()=>{
        const { day: day_2, month: month_2, year: year_2 } = dateRef.current;
        triggerOnChange({
            day: day_2,
            month: month_2,
            year: year_2 + 1,
            type: 'nextYear'
        });
    }, [
        triggerOnChange
    ]);
    const handleClickPrevMonth = (0, $cozmU.useCallback)(()=>{
        const { day: day_3, month: month_3, year: year_3 } = {
            ...dateRef.current,
            ...$0dcfeb64fb14a2d7$var$getPrevMonth(dateRef.current.month, dateRef.current.year)
        };
        triggerOnChange({
            day: day_3,
            month: month_3,
            year: year_3,
            type: 'prevMonth'
        });
    }, [
        triggerOnChange
    ]);
    const handleClickPrevYear = (0, $cozmU.useCallback)(()=>{
        const { day: day_4, month: month_4, year: year_4 } = dateRef.current;
        triggerOnChange({
            day: day_4,
            month: month_4,
            year: year_4 - 1,
            type: 'prevYear'
        });
    }, [
        triggerOnChange
    ]);
    return {
        navigate: navigate,
        handleClickNextMonth: handleClickNextMonth,
        handleClickNextYear: handleClickNextYear,
        handleClickPrevMonth: handleClickPrevMonth,
        handleClickPrevYear: handleClickPrevYear
    };
};
var $0dcfeb64fb14a2d7$export$2e2bcd8739ae039 = $0dcfeb64fb14a2d7$var$useHandleDateChange;
module.exports["default"] = $0dcfeb64fb14a2d7$export$2e2bcd8739ae039;

});

parcelRegister("3f826", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $blHSj = parcelRequire("blHSj");

const $93dd0d18d735b0a5$var$arrowKeys = {
    ArrowDown: 'down',
    ArrowLeft: 'left',
    ArrowRight: 'right',
    ArrowUp: 'up'
};
// eslint-disable-next-line @repo/internal/react/require-jsdoc
const $93dd0d18d735b0a5$var$useHandleDateSelect = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useHandleDateSelect(t0) {
    const $ = (0, $bDgLe.c)(22);
    const { day: t1, month: t2, year: t3, selected: t4, previous: t5, onSelect: onSelect, navigate: navigate } = t0;
    const [dayValue] = t1;
    const [monthValue] = t2;
    const [yearValue] = t3;
    const [selectedValue, setSelectedValue] = t4;
    const [, setPreviouslySelectedValue] = t5;
    let t6;
    if ($[0] !== dayValue || $[1] !== monthValue || $[2] !== yearValue) {
        t6 = {
            day: dayValue,
            month: monthValue,
            year: yearValue
        };
        $[0] = dayValue;
        $[1] = monthValue;
        $[2] = yearValue;
        $[3] = t6;
    } else t6 = $[3];
    const dateRef = (0, $cozmU.useRef)(t6);
    let t7;
    let t8;
    if ($[4] !== dayValue || $[5] !== monthValue || $[6] !== yearValue) {
        t7 = ()=>{
            dateRef.current = {
                day: dayValue,
                month: monthValue,
                year: yearValue
            };
        };
        t8 = [
            dayValue,
            monthValue,
            yearValue
        ];
        $[4] = dayValue;
        $[5] = monthValue;
        $[6] = yearValue;
        $[7] = t7;
        $[8] = t8;
    } else {
        t7 = $[7];
        t8 = $[8];
    }
    (0, $cozmU.useEffect)(t7, t8);
    let t9;
    if ($[9] !== onSelect || $[10] !== selectedValue || $[11] !== setPreviouslySelectedValue || $[12] !== setSelectedValue) {
        t9 = (t10)=>{
            const { year: year, month: month, day: day } = t10;
            const iso = (0, $blHSj.default)({
                year: year,
                month: month,
                day: day
            });
            onSelect({
                day: day,
                month: month,
                year: year,
                iso: iso
            });
            setPreviouslySelectedValue(selectedValue);
            setSelectedValue([
                iso
            ]);
        };
        $[9] = onSelect;
        $[10] = selectedValue;
        $[11] = setPreviouslySelectedValue;
        $[12] = setSelectedValue;
        $[13] = t9;
    } else t9 = $[13];
    const triggerOnSelect = t9;
    let t10;
    if ($[14] !== triggerOnSelect) {
        t10 = (t11)=>{
            const { year: year_0, month: month_0, day: day_0 } = t11;
            triggerOnSelect({
                year: year_0,
                month: month_0,
                day: day_0
            });
        };
        $[14] = triggerOnSelect;
        $[15] = t10;
    } else t10 = $[15];
    const handleClickDay = t10;
    let t11;
    if ($[16] !== navigate || $[17] !== triggerOnSelect) {
        t11 = (e)=>{
            const { key: key } = e;
            const arrowKey = $93dd0d18d735b0a5$var$arrowKeys[key];
            if (key === "Enter" || key === " ") {
                e.preventDefault();
                triggerOnSelect(dateRef.current);
            } else if (arrowKey) {
                e.preventDefault();
                navigate(arrowKey);
            }
        };
        $[16] = navigate;
        $[17] = triggerOnSelect;
        $[18] = t11;
    } else t11 = $[18];
    const handleContainerKeyDown = t11;
    let t12;
    if ($[19] !== handleClickDay || $[20] !== handleContainerKeyDown) {
        t12 = {
            handleClickDay: handleClickDay,
            handleContainerKeyDown: handleContainerKeyDown
        };
        $[19] = handleClickDay;
        $[20] = handleContainerKeyDown;
        $[21] = t12;
    } else t12 = $[21];
    return t12;
} : function useHandleDateSelect({ day: [dayValue], month: [monthValue], year: [yearValue], selected: [selectedValue, setSelectedValue], previous: [, setPreviouslySelectedValue], onSelect: onSelect, navigate: navigate }) {
    const dateRef = (0, $cozmU.useRef)({
        day: dayValue,
        month: monthValue,
        year: yearValue
    });
    (0, $cozmU.useEffect)(()=>{
        dateRef.current = {
            day: dayValue,
            month: monthValue,
            year: yearValue
        };
    }, [
        dayValue,
        monthValue,
        yearValue
    ]);
    const triggerOnSelect = (0, $cozmU.useCallback)(({ year: year, month: month, day: day })=>{
        const iso = (0, $blHSj.default)({
            year: year,
            month: month,
            day: day
        });
        onSelect({
            day: day,
            month: month,
            year: year,
            iso: iso
        });
        setPreviouslySelectedValue(selectedValue);
        setSelectedValue([
            iso
        ]);
    }, [
        onSelect,
        selectedValue,
        setPreviouslySelectedValue,
        setSelectedValue
    ]);
    const handleClickDay = (0, $cozmU.useCallback)(({ year: year_0, month: month_0, day: day_0 })=>{
        triggerOnSelect({
            year: year_0,
            month: month_0,
            day: day_0
        });
    }, [
        triggerOnSelect
    ]);
    const handleContainerKeyDown = (0, $cozmU.useCallback)((e)=>{
        const { key: key } = e;
        const arrowKey = $93dd0d18d735b0a5$var$arrowKeys[key];
        if (key === 'Enter' || key === ' ') {
            e.preventDefault();
            triggerOnSelect(dateRef.current);
        } else if (arrowKey) {
            e.preventDefault();
            navigate(arrowKey);
        }
    }, [
        triggerOnSelect,
        navigate
    ]);
    return {
        handleClickDay: handleClickDay,
        handleContainerKeyDown: handleContainerKeyDown
    };
};
var $93dd0d18d735b0a5$export$2e2bcd8739ae039 = $93dd0d18d735b0a5$var$useHandleDateSelect;
module.exports["default"] = $93dd0d18d735b0a5$export$2e2bcd8739ae039;

});

parcelRegister("dEHey", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $3vMGL = parcelRequire("3vMGL");


var $iDrrr = parcelRequire("iDrrr");

// eslint-disable-next-line @repo/internal/react/require-jsdoc
const $59e91aec054ca8c1$var$useLocale = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useLocale(t0) {
    const $ = (0, $bDgLe.c)(18);
    const { locale: locale, weekStartDay: weekStartDay } = t0;
    let t1;
    if ($[0] !== locale) {
        t1 = (0, $3vMGL.createLocalizationProvider)(locale);
        $[0] = locale;
        $[1] = t1;
    } else t1 = $[1];
    const l10n = t1;
    let t2;
    if ($[2] !== l10n || $[3] !== weekStartDay) {
        t2 = weekStartDay ?? ((0, $iDrrr.fg)("platform-dst-locale-week-start-day") ? l10n.getFirstDayOfWeek() : 0);
        $[2] = l10n;
        $[3] = weekStartDay;
        $[4] = t2;
    } else t2 = $[4];
    const resolvedWeekStartDay = t2;
    let t3;
    if ($[5] !== l10n) {
        t3 = l10n.getMonthsLong();
        $[5] = l10n;
        $[6] = t3;
    } else t3 = $[6];
    const monthsLong = t3;
    let t4;
    if ($[7] !== l10n || $[8] !== resolvedWeekStartDay) {
        t4 = l10n.getDaysShort(resolvedWeekStartDay);
        $[7] = l10n;
        $[8] = resolvedWeekStartDay;
        $[9] = t4;
    } else t4 = $[9];
    const daysShort = t4;
    let t5;
    if ($[10] !== l10n || $[11] !== resolvedWeekStartDay) {
        t5 = l10n.getDaysLong(resolvedWeekStartDay);
        $[10] = l10n;
        $[11] = resolvedWeekStartDay;
        $[12] = t5;
    } else t5 = $[12];
    const daysLong = t5;
    let t6;
    if ($[13] !== daysLong || $[14] !== daysShort || $[15] !== monthsLong || $[16] !== resolvedWeekStartDay) {
        t6 = {
            monthsLong: monthsLong,
            daysShort: daysShort,
            daysLong: daysLong,
            weekStartDay: resolvedWeekStartDay
        };
        $[13] = daysLong;
        $[14] = daysShort;
        $[15] = monthsLong;
        $[16] = resolvedWeekStartDay;
        $[17] = t6;
    } else t6 = $[17];
    return t6;
} : function useLocale({ locale: locale, weekStartDay: weekStartDay }) {
    const l10n = (0, $cozmU.useMemo)(()=>(0, $3vMGL.createLocalizationProvider)(locale), [
        locale
    ]);
    const resolvedWeekStartDay = (0, $cozmU.useMemo)(()=>weekStartDay ?? ((0, $iDrrr.fg)('platform-dst-locale-week-start-day') ? l10n.getFirstDayOfWeek() : 0), [
        l10n,
        weekStartDay
    ]);
    const monthsLong = (0, $cozmU.useMemo)(()=>l10n.getMonthsLong(), [
        l10n
    ]);
    const daysShort = (0, $cozmU.useMemo)(()=>l10n.getDaysShort(resolvedWeekStartDay), [
        l10n,
        resolvedWeekStartDay
    ]);
    const daysLong = (0, $cozmU.useMemo)(()=>l10n.getDaysLong(resolvedWeekStartDay), [
        l10n,
        resolvedWeekStartDay
    ]);
    return {
        monthsLong: monthsLong,
        daysShort: daysShort,
        daysLong: daysLong,
        weekStartDay: resolvedWeekStartDay
    };
};
var $59e91aec054ca8c1$export$2e2bcd8739ae039 = $59e91aec054ca8c1$var$useLocale;
module.exports["default"] = $59e91aec054ca8c1$export$2e2bcd8739ae039;

});

parcelRegister("a0UNJ", function(module, exports) {
/* fixed-layer.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $8aG6j = parcelRequire("8aG6j");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $dpsRj = parcelRequire("dpsRj");


var $kFchK = parcelRequire("kFchK");


var $lQV5m = parcelRequire("lQV5m");


var $akErP = parcelRequire("akErP");


var $kN1yU = parcelRequire("kN1yU");

function $6d6e390f276bb723$var$_defineProperty(e, r, t) {
    return (r = $6d6e390f276bb723$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $6d6e390f276bb723$var$_toPropertyKey(t) {
    var i = $6d6e390f276bb723$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $6d6e390f276bb723$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $6d6e390f276bb723$var$styles = {
    root: "_0KLXrujOvk _1mT5xdWVPG _2I62gzPgdg",
    popperStyles: "_42Yu6BPvK5"
};
class $6d6e390f276bb723$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    componentDidUpdate(prevProps) {
        if (prevProps.inputValue !== this.props.inputValue) this.update();
    }
    render() {
        const { containerRef: containerRef, content: content, testId: testId } = this.props; // Wait for containerRef callback to cause a re-render
        if (!containerRef) return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {});
        const divStyles = {
            height: containerRef.getBoundingClientRect().height,
            // Don't block the clear button
            width: containerRef.getBoundingClientRect().width - parseInt((0, $kFchK.sizes).small.slice(0, -2)) - 8
        };
        return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $akErP.Manager), {
            children: [
                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kN1yU.Reference), {
                    children: ({ ref: ref })=>/*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                            ref: ref,
                            "data-layer-child": true,
                            style: divStyles,
                            className: (0, $hekY6.default)([
                                $6d6e390f276bb723$var$styles.root
                            ])
                        })
                }),
                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lQV5m.Popper), {
                    children: ({ ref: ref, style: style, update: update })=>{
                        this.update = update;
                        return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                            ref: ref,
                            style: style,
                            "data-testid": testId && `${testId}--popper--container`,
                            className: (0, $hekY6.default)([
                                $6d6e390f276bb723$var$styles.popperStyles
                            ]),
                            children: content
                        });
                    }
                })
            ]
        });
    }
    constructor(...args){
        super(...args);
        $6d6e390f276bb723$var$_defineProperty(this, "update", (0, $dpsRj.default));
    }
}
module.exports["default"] = $6d6e390f276bb723$export$2e2bcd8739ae039;

});

parcelRegister("kFchK", function(module, exports) {
const $fb7c93407752e609$export$c647cb0ee6e282fe = {
    small: '16px',
    medium: '24px',
    large: '32px',
    xlarge: '48px'
};
const $fb7c93407752e609$export$7bd66fc94c81bf84 = {
    small: 'small',
    medium: 'medium',
    large: 'large',
    xlarge: 'xlarge'
};
const $fb7c93407752e609$export$62ad7b0c781000e9 = {
    small: {
        width: $fb7c93407752e609$export$c647cb0ee6e282fe.small,
        height: $fb7c93407752e609$export$c647cb0ee6e282fe.small
    },
    medium: {
        width: $fb7c93407752e609$export$c647cb0ee6e282fe.medium,
        height: $fb7c93407752e609$export$c647cb0ee6e282fe.medium
    },
    large: {
        width: $fb7c93407752e609$export$c647cb0ee6e282fe.large,
        height: $fb7c93407752e609$export$c647cb0ee6e282fe.large
    },
    xlarge: {
        width: $fb7c93407752e609$export$c647cb0ee6e282fe.xlarge,
        height: $fb7c93407752e609$export$c647cb0ee6e282fe.xlarge
    }
};
module.exports["sizes"] = $fb7c93407752e609$export$c647cb0ee6e282fe;

});

parcelRegister("cME0o", function(module, exports) {
/* menu-top-layer.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $esV19 = parcelRequire("esV19");

var $k5sGX = parcelRequire("k5sGX");


var $buG8Z = parcelRequire("buG8Z");

function $8f98c8fc52ca556a$var$getValidDate(isos) {
    return isos.reduce((acc, iso)=>{
        const date = (0, $k5sGX.default)(iso);
        return (0, $esV19.default)(date) ? {
            day: date.getDate(),
            month: date.getMonth() + 1,
            year: date.getFullYear()
        } : acc;
    }, {});
}
const $8f98c8fc52ca556a$var$styles = {
    root: "_0bjKvD8fU6 _39xV02W9qI _0KLXruoI2d _2OUyjtGk8v _43nrzT2ADO _0rIjyk2ADO"
}; /**
    * Top-layer version of the date picker menu.
    *
    * The surrounding react-select menu portal owns the native popover and
    * positioning. This component only supplies the calendar dialog content.
    *
    * Gated behind the `platform-dst-top-layer` feature flag.
    */ 
const $8f98c8fc52ca556a$export$11ed8c2ae184f5b3 = ({ selectProps: selectProps, innerProps: innerProps })=>{
    const { calendarValue: calendarValue, calendarView: calendarView, menuInnerWrapper: MenuInnerWrapper } = selectProps;
    const { day: day, month: month, year: year } = $8f98c8fc52ca556a$var$getValidDate([
        calendarValue,
        calendarView
    ]);
    const onMenuMouseDown = (event)=>{
        if (event.button !== 0) return;
        event.stopPropagation();
        event.preventDefault();
    };
    const Wrapper = typeof MenuInnerWrapper === 'function' ? MenuInnerWrapper : (0, $cozmU.Fragment);
    return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        ...innerProps,
        onMouseDown: onMenuMouseDown,
        role: "presentation",
        className: (0, $hekY6.default)([
            $8f98c8fc52ca556a$var$styles.root
        ]),
        children: /*#__PURE__*/ (0, $8aG6j.jsx)(Wrapper, {
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $buG8Z.default), {
                day: day,
                month: month,
                year: year,
                disabled: selectProps.calendarDisabled,
                disabledDateFilter: selectProps.calendarDisabledDateFilter,
                minDate: selectProps.calendarMinDate,
                maxDate: selectProps.calendarMaxDate,
                nextMonthLabel: selectProps.nextMonthLabel,
                onChange: selectProps.onCalendarChange,
                onSelect: selectProps.onCalendarSelect,
                previousMonthLabel: selectProps.previousMonthLabel,
                ref: selectProps.calendarRef,
                selected: [
                    selectProps.calendarValue
                ],
                shouldSetFocusOnCurrentDay: selectProps.shouldSetFocusOnCurrentDay,
                locale: selectProps.calendarLocale,
                testId: selectProps.testId && `${selectProps.testId}--calendar`,
                weekStartDay: selectProps.calendarWeekStartDay
            })
        })
    });
};
module.exports["MenuTopLayer"] = $8f98c8fc52ca556a$export$11ed8c2ae184f5b3;

});

parcelRegister("lzTfS", function(module, exports) {
/**
 * Everything in this file is to smooth out the migration of the new date picker
 * (https://product-fabric.atlassian.net/browse/DSP-20682). When that ticket is
 * complete, all of these functions will ilkely be merged back into the date
 * picker. Please do not pre-optimize and put these back into the date picker
 * unless you are working on the DTP Refresh and you have a good reason to do
 * so, thank you!
 *
 * All variables within the `di` objects are dependency injections. They should
 * be read from within the component at the end of the day. But because we are
 * extracting them, we have to inject them in every place manually. When we
 * re-introduce them to the components, we can likely remove the `di` variables
 * and instead use internal variables.
 *
 * If component _only_ has injected variables, it is fully internal and was
 * broken out to be it's own function.
 */ // oxlint-disable-next-line @atlassian/no-restricted-imports

var $esV19 = parcelRequire("esV19");

var $hSoEi = parcelRequire("hSoEi");


var $iDrrr = parcelRequire("iDrrr");


var $5NE0I = parcelRequire("5NE0I");


var $78xYN = parcelRequire("78xYN");

const $ed996f3d2fbc5c29$export$6b862160d295c8e = (date, di)=>{
    const { parseInputValue: parseInputValue, dateFormat: dateFormat, l10n: l10n } = di;
    if (parseInputValue) return parseInputValue(date, dateFormat || (0, $5NE0I.defaultDateFormat));
    if (dateFormat) {
        // date-fns uses the reference year to resolve two-digit years and fill
        // omitted years. Use the current local date rather than the Unix epoch.
        const referenceDate = (0, $iDrrr.fg)('platform-dst-dp-current-reference-date') ? new Date() : new Date(0);
        const parsed = (0, $hSoEi.default)(date, (0, $78xYN.convertTokens)(dateFormat), referenceDate);
        // `dateFormat` is a display format, so typed input does not always match
        // it. Locale parsing stays as the fallback so those entries still work.
        if ((0, $esV19.default)(parsed)) return parsed;
    }
    return l10n.parseDate(date);
};
module.exports["parseDate"] = $ed996f3d2fbc5c29$export$6b862160d295c8e;

});

parcelRegister("ep7Ex", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $l9ukq = parcelRequire("l9ukq");

const $f78c8b131116f7c9$export$6e30bf8cb1347b56 = // TODO: Make ID required
({ id: id, lang: lang })=>({ children: children, className: className, clearValue: clearValue, cx: cx, data: data, getStyles: getStyles, getValue: getValue, hasValue: hasValue, isDisabled: isDisabled, isMulti: isMulti, isRtl: isRtl, options: options, selectOption: selectOption, selectProps: selectProps, setValue: setValue, ...rest })=>{
        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $l9ukq.components).SingleValue, {
            ...rest,
            // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-classname-prop
            className: className,
            clearValue: clearValue,
            cx: cx,
            data: data,
            getStyles: getStyles,
            getValue: getValue,
            hasValue: hasValue,
            innerProps: {
                id: id,
                lang: lang.replace('_', '-')
            },
            isDisabled: isDisabled,
            isMulti: isMulti,
            isRtl: isRtl,
            options: options,
            selectOption: selectOption,
            selectProps: selectProps,
            setValue: setValue,
            children: children
        });
    };
module.exports["makeSingleValue"] = $f78c8b131116f7c9$export$6e30bf8cb1347b56;

});


//# sourceMappingURL=ConfluenceSearchConfigModal.7fa86dc0.js.map
